export default {
  en: {
    /* ----- Productivity Monitoring ----- */
    // Section titles
    // Reports section headers
    productivityReports: "Productivity Reports",
    analyticalReports: "Analytical Reports",
    summaryReports: "Summary Reports",
    dlpReports: "Data Loss Prevention(DLP) Reports",
    locationIntelligence: "Location Intelligence",
    assetReport: "Asset Report",

    // Report headers and content
    timeActivityReport: "Time & Activity Report",
    timeActivityReportContent:
      "Generate reports for active and productive time.",
    attendanceReport: "Attendance Report",
    attendanceReportContent:
      "Generate attendance reports with check-in/checkout time along with total active time and productive time.",
    appsReport: "Apps Report",
    appsReportContent: "Generate reports for apps usage during active hours.",
    appsTitleReport: "Apps Title Report",
    urlsReport: "URLs Report",
    urlsReportContent: "Generate reports for URLs usage during active hours.",
    productiveAppsReport: "Productive Apps Report",
    productiveAppsReportContent:
      "Generate reports for productive apps usage during active hours.",
    productiveURLsReport: "Productive URLs Report",
    productiveURLsReportContent:
      "Generate reports for productive URLs usage during active hours.",
    consolidatedAppsURLsReport: "Consolidated Apps & URLs Report",
    consolidatedAppsURLsReportContent:
      "Generate reports for consolidated apps & URLs usage during active hours.",
    efficiencyReport: "Efficiency Report",
    efficiencyReportContent:
      "Generate reports for highly efficient team members.",
    lowActivityReport: "Low Activity Report",
    lowActivityReportContent:
      "Generate reports for low activity during business hours.",
    productivitySummaryReport: "Productivity Summary Report",
    productivitySummaryReportContent:
      "Generate reports for productivity user activities on all metrics by day.",
    productiveUnproductiveSummaryReport:
      "Productive and Unproductive Summary Report",
    productiveUnproductiveSummaryReportContent:
      "Generate reports for both productive and unproductive user activities on all metrics by day",
    productiveAppsMetric: "Productive Apps Metric",
    productiveAppsMetricContent:
      "Generate reports for productive apps with unique user volume.",
    productiveURLsMetric: "Productive URLs Metric",
    productiveURLsMetricContent:
      "Generate reports for productive URLs with unique user volume.",
    unproductiveAppsMetrics: "Unproductive Apps Metrics",
    unproductiveAppsMetricsContent:
      "Generate reports with unproductive and uncategorized apps with unique user volume.",
    unproductiveURLsMetric: "Unproductive URLs Metric",
    unproductiveURLsMetricContent:
      "Generate reports with unproductive and uncategorized URLs with unique user volume.",
    monthlySummaryReport: "Monthly Summary Report",
    monthlySummaryReportContent:
      "Generate a summary report for user activity on computer and software.",
    weeklySummaryReport: "Weekly Summary Report",
    weeklySummaryReportContent:
      "Generate a summary report for user activity on computer and software.",
    fileWebFileEventSummaryReport: "File and Web File Event Summary Report",
    fileWebFileEventSummaryReportContent:
      "Generate a summary report for user activity on web file and file events.",
    fileEventReport: "File Event Report",
    fileEventReportContent:
      "Generate a report for user activity on file events.",
    webFileEventReport: "Web File Event Report",
    webFileEventReportContent:
      "Generate a report for user activity on web file events.",
    locationIntelligenceReport: "Location Intelligence Report",
    locationIntelligenceReportContent:
      "Generate a report for user activity based on their location",
    locationIntelligenceMonthlySummaryReport:
      "Location Intelligence Monthly Summary Report",
    locationIntelligenceMonthlySummaryReportContent:
      "Generate a report for user activity based on their location",
    assetReportHeader: "Asset Report",
    usersInCoreHrNote: "Users in Core HR",
    inviteInitiatedFor: "Invite initiated for",
    membersSuccessfully: "member(s) successfully",
    checkInviteesStatusInInvitesTab: "Check invitees status in invites tab",
    resendInvitationInitiatedSuccessfully:
      "Resend invitation initiated successfully",
    assetReportContent:
      "Generate asset report with mac address, operating system and user details.",

    // Export related
    export: "Export",
    editColumns: "Edit Columns",
    columnConfigurationSavedSuccessfully:
      "Column configuration saved successfully",
    errorSavingColumnConfiguration: "Error saving column configuration",
    employeeId: "EmployeeId",
    employeeFirstName: "Employee First Name",
    employeeLastName: "Employee Last Name",
    systemUserName: "System User Name",
    employeeEmail: "Employee Email address",
    manager: "Manager",
    department: "Department",
    designation: "Designation",
    serialNumber: "Serial Number",
    macAddress: "MAC Address",
    computerName: "Computer Name",
    assetType: "Asset Type",
    operatingSystem: "Operating System",
    agentVersion: "Agent Version",
    status: "Status",
    noAccessToAddLicenses: "Auto billing is not applicable.",
    // Error messages
    technicalDifficultiesExportingReport:
      "It's us! There seems to be some technical difficulties while exporting the report. Please try after some time.",
    noAccessRightsToViewReports:
      "Sorry, you don't have access rights to view reports. Please contact your administrator",
    somethingWentWrongExportingReport:
      "Something went wrong while exporting the report. If you continue to see this issue, please contact the platform administrator.",
    technicalDifficultiesSource:
      "It's us! There seems to be some technical difficulties while fetching the {source} details. Please try after some time.",
    noAccessRights:
      "Sorry, you don't have access rights to view your {source} details. Please contact the HR administrator.",
    somethingWentWrong:
      "Something went wrong while fetching the {source} details. If you continue to see this issue, please contact the platform support team.",
    appsUsage: "apps usage",

    // AllReportsExportModal translations
    reportFileFormat: "Report File Format",
    reportHeaders: "Report Headers",
    show: "Show",
    change: "Change",
    excludeWeekOff: "Exclude Week off",
    reportFor: "Report For",
    select: "Select",
    viewAll: "View All",
    appsType: "Apps Type",
    organizationLevelBenchmark:
      'The organization level, "{settingsType}", will be used as a benchmark for the reporting outcome.',
    exportButton: "Export",
    noSearchResultsFound: "No search results found",
    save: "Save",
    chooseEmployee: "Choose Employee",
    xlsx: "XLSX",
    csv: "CSV",
    individual: "Individual",
    team: "Team",
    no: "No",
    yes: "Yes",
    all: "All",
    business: "Business",
    collaborative: "Collaborative",
    yesterday: "Yesterday",
    last7Days: "Last 7 days",
    lastWeek: "Last week",
    last2Weeks: "Last 2 weeks",
    thisMonth: "This month",
    lastMonth: "Last month",
    activityGoalsSettings: "Activity Goals Settings",
    appsAndURLsSettings: "Apps and URLs Settings",
    noDataAvailableForSelectedCriteria:
      "There is no data available for the selected criteria. Please try with a different date range.",
    noDataAvailableForSelectedPeriod:
      "There is no data available for the selected period. Please try with a different date range.",
    exportReportFor31DaysOrLess: "Please export the report for 31 days or less",
    exportReportFor7DaysOrLess: "Please export the report for 7 days or less",

    teamActivityDashboard: "Team Activity Dashboard",
    myActivityDashboard: "My Activity Dashboard",
    productivityMonitoring: "Productivity Monitoring",
    activityTracker: "Activity Tracker",
    myActivity: "My Activity",
    myTeamActivity: "My Team Activity",
    members: "Members",

    // Team Members
    licenses: "Licenses",
    add: "Add",
    invite: "Invite",
    invites: "Invites",
    invited: "Invited",
    inactive: "Inactive",
    purchased: "Purchased",
    assigned: "Assigned",
    available: "Available",
    resendInvite: "Resend Invite",
    inviteMembers: "Invite Members",
    onboardMembers: "Onboard Members",
    adminsManagers: "Admins/Managers",
    employees: "Employees",
    invitedDate: "Invited Date",
    computerNameHeader: "Computer Name",
    exportAdminsManagers: "Export Admins/Managers",
    exportMembers: "Export Members",
    inviteAdminsManagers: "Invite Admins/Managers",
    addAtLeastOneUserToInvite: "Add atleast one user to invite",
    inviteNewAdminsManagers: "Invite New Admins/Managers",
    addAccessDeniedMsg:
      "Sorry, you don't have access to add members. Please contact your HR administrator.",
    inviteAdminsManagersTrackActivities:
      "Please invite your admins/managers and track their activities",
    inviteTeamMembersTrackActivity:
      "Please invite your team members and track your team members activity",
    noAccessToInvite:
      "Sorry, you don't have access to invite any members. Please contact system administrator.",
    resendInviteTooltip: "For resend, you have to choose atleast one record.",
    noRightsToResendInvite:
      "Sorry, you don't have rights to resend invite. Please contact your admin.",
    noAccessToUpdateMembers:
      "Sorry, you don't have access to update team members. Please contact your HR administrator.",
    pleaseInviteAdminsManagersAndTrack:
      "Please invite your admins/managers and track their activities",

    // Member Details
    employeeIdDetail: "Employee Id",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    departmentDetail: "Department",
    designationDetail: "Designation",
    reportingManager: "Reporting Manager",
    operatingSystemDetail: "Operating System",
    agentVersionDetail: "Agent Version",
    statusDetail: "Status",

    // Activity Tracker tabs
    activityTrackerTab1: "Activity Tracker",
    activityTrackerTab2: "My Activity",
    activityTrackerTab3: "My Team Activity",
    activityTrackerTab4: "Members",
    activityTrackerTab5: "Team Activity Dashboard",
    activityTrackerTab6: "My Activity Dashboard",
    activityTrackerTab7: "CXO Dashboard",

    // Employee Data Management tabs
    employeeDataManagementTab1: "Employee Data",
    employeeDataManagementTab2: "User Accounts",
    employeeDataManagementTab3: "Signatories",
    employeeDataManagementTab4: "Accreditation",

    // Dashboard sections
    overview: "Overview",
    employeeProductivity: "Employee Productivity",
    departmentPerformance: "Department Performance",
    timeTracking: "Time Tracking",

    // Table headers
    employeeName: "Employee Name",
    departmentHeader: "Department",
    activityLevel: "Activity Level",
    timeTracked: "Time Tracked",
    startTime: "Start Time",
    endTime: "End Time",
    duration: "Duration",
    statusHeader: "Status",
    trackingStatus: "Tracking Status",
    userStatus: "User Status",
    actions: "Actions",
    utilizationMargin: "Utilization Margin",

    // Dashboard metrics
    totalEmployees: "Total Employees",
    activeEmployees: "Active Employees",
    averageProductivity: "Average Productivity",
    productivityScore: "Productivity Score",
    topPerformers: "Top Performers",
    lowPerformers: "Low Performers",
    productivityTrend: "Productivity Trend",
    hoursWorked: "Hours Worked",
    activeDuration: "Active Duration",
    idleDuration: "Idle Duration",
    timeInHours: "Time in hours",
    totalTimeInHours: "Total time in hours",
    productivityTrendPeriod: "Productivity trend over a given period",
    workedToday: "Worked Today",
    todaysActivity: "Today's Activity",
    workedThisWeek: "Worked this Week",
    weeklyActivity: "Weekly Activity",
    myTeamWeeklyActivity: "My Team Weekly Activity",
    myWeeklyActivity: "My Weekly Activity",
    technicalDifficulties:
      "There seems to be some technical difficulties while fetching data",
    numberOfEmployees: "Number of Employees",
    high: "High",
    moderate: "Moderate",
    low: "Low",
    activityPercentage: "Activity Percentage",
    activityData: "Activity Data",
    topAppsAndUrls: "Top Apps & URLs of the week",
    focusOnSocial: "Focus on how to be social,",
    notOnHowToDoSocial: "not on how to do social.",
    topAppsOfWeek: "Top Apps of the week",
    topUrlsOfWeek: "Top URLs of the week",
    topAppsOfDay: "Top 5 Apps of the day",
    topUrlsOfDay: "Top 5 URLs of the day",
    hours: "Hours",
    recentScreenshots: "Recent Screenshots",
    viewAllLink: "view all",
    weaponsDangerous: "Weapons are dangerous",
    wordsArePowerful: "Words are powerful. Now then, screenshots are too!",
    focusOnBeing: "Focus on being",
    productiveInsteadOfBusy: "productive instead of busy.",
    keyToAchievingSuccess: "A key to achieving success",
    assembleStrongStableManagementTeam:
      "is to assemble a strong and stable management team.",

    // Location types
    officeRemote: "Office/Remote",
    office: "Office",
    remote: "Remote",
    allFilter: "All",

    // Filter labels
    dateRange: "Date Range",
    activityType: "Activity Type",

    // Buttons and actions
    addNew: "Add New",
    resetFilterSearch: "Reset Filter/Search",
    exportAction: "Export",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    close: "Close",
    saveButton: "Save",
    submit: "Submit",
    cancel: "Cancel",
    back: "Back",
    changeButton: "Change",
    download: "Download",
    downloadClient: "Download Client",
    send: "Send",
    shareDashboard: "Share Dashboard",
    privacy: "Privacy",
    date: "Date",
    workSchedule: "Work Schedule",
    timezone: "Timezone",
    myDefaultView: "My Default View",
    selectManager: "Select Manager",
    managerLabel: "Manager",
    noDataAvailable: "No data available",
    to: "To",
    body: "Body",
    skip: "Skip",
    next: "Next",
    inviteLater: "Invite Later",
    version: "Version",

    // Admin Activation Screen
    introducing: "Introducing",
    welcomeTo: "Welcome to",
    productivityMonitoringSolution:
      "Fully integrated Productivity Monitoring solution to track the employee's activity in near real time. You can configure to capture random screenshots with an option to blur them. Your team's productivity is measured based on their activity on keyboard and mouse.",
    noRightsToActivateAccount:
      "You don't have rights to activate your account. Please contact your admin.",
    learnMore: "Learn More",

    // Core User Invited Screen
    inviteAcceptanceMessage:
      'You\'ve been sent an invite for acceptance. Please check your inbox. If you did not receive the acceptance email, please click the "request access" button for resending the invitation.',
    requestAccess: "Request Access",

    // Core User Not Invited Screen
    assistsTrackingTimeProductivity:
      "Assists you in tracking time and productivity.",

    // EmpMonitorIntroScreen2
    howDoYouLikeToTrackUserActivities:
      "How do you like to track user activities?",
    consentBased: "Consent Based",
    stealthMode: "Stealth Mode",
    consentBasedTrackingDescription:
      "Consent based tracking helps employees to decide when they would like to start and stop tracking. Getting voluntary informed consent from all of your employees is the best possible outcome, but consent-based tracking is reserved for a perfect world that we don't live in now.",
    stealthModeTrackingDescription:
      "Stealth mode tracking enables hidden mode and starts working automatically when the user activates their PC. It doesn't interfere with the user's work and provides crucial information about their productivity.",
    technicalDifficultiesTrackingMode:
      "It's us! There seems to be some technical difficulties while choosing your activity tracker app tracking mode. Please try after some time.",
    errorChoosingTrackingMode:
      "Something went wrong while choosing your activity tracker app tracking mode. If you continue to see this issue, please contact the platform administrator.",

    // EmpMonitorIntroScreen3
    downloadDesktopAgentHere: "Download the desktop agent here",
    downloadDesktopClientHere:
      "Download the desktop client here, based on your operating system",
    watchVideoTutorialFor: "Please watch the video tutorial here for",
    osDesktop: "OS desktop",
    installationAndOperationalFlow: "installation and its operational flow.",
    assetAndEmployeeOnboardingFlow: "Asset and employee onboarding flow",
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    step4: "Step 4",
    step5: "Step 5",
    downloadTheAgent: "Download the agent",
    installAgentOnEndpoint: "Install the agent on the endpoint to be monitored",
    endpointsScannedAssetDetails:
      "Endpoints are scanned, and asset details such as Mac Address, Computer Name, Operating System, and Agent version are pushed to asset registry in cloud",
    associateOwnerToAsset:
      "Associate owner(Employee) to the asset in cloud application",
    keystrokesMouseAppsMonitored:
      "Keystrokes, Mouse, Apps, and internet usage are monitored with random screenshots",
    desktopDownloadNotAvailable:
      "Desktop {0} download is not available. Please contact the platform administrator.",
    unableToDownloadApplication:
      "Unable to download the application. Would you mind trying after some time or contact system administrator?",

    // EmpMonitorIntroScreen4
    onboardYourTeam: "Onboard your team",
    fewStepsAwayToStartMonitoring:
      "You are few steps away to start monitoring the team's productivity.",
    watchVideoTutorialToLearnHowToOnboard:
      "Please watch the video tutorial to learn how to onboard your team members.",
    noRightsToInviteMembers:
      "You don't have rights to invite members into activity tracker. Please contact your admin.",

    // EmpMonitorTimeZonePopup
    timeZone: "Time Zone",
    timeZoneLabel: "TimeZone",
    activityTrackerSummarises:
      "Activity tracker summarises all effort into days, weeks and months based on the time zone of the Organization. This aggregated data is then used for reports and other insights.",
    technicalDifficultiesWhileUpdatingTimezone:
      "It's us! There seems to be some technical difficulties while updating the timezone. Please try after some time.",
    somethingWentWrongWhileUpdatingTimezone:
      "Something went wrong while updating the timezone. Would you mind trying again?",

    // EmpOnboardInvitesDataTable
    selectAll: "Select All",
    noEmployeesMatchYourSearch: "No employees match your search",
    role: "Role",
    resend: "Resend",
    retry: "Retry",
    pleaseInviteYourTeamMembers:
      "Please invite your team members to track their activities.",
    exportInvitees: "Export Invitees",
    memberInvitees: "Member Invitees",
    emailAddress: "Email Address",
    proceed: "Proceed",
    areYouSureToDeleteTheInvitedMember:
      "Are you sure to delete the invited member?",

    // EditTeamMembers
    chooseManager: "Choose Manager",
    active: "Active",
    pending: "Pending",
    currently: "Currently",
    hasGot: "has got",
    employeesAsDirectReportees:
      "employees as direct reportee(s). Please choose a new manager for all employees before changing the role.",
    cannotDeactivateEmployee:
      "You cannot deactivate the employee at this moment.",
    isManagerHavingDirectReportees:
      "is a manager having direct reportees. Please change the employee's role to a team member and assign a new manager for all reportees before deactivation.",
    deactivatingAccountConfirmation:
      "You are deactivating your account. Once confirmed, you will not be able to access the application(Desktop & Web). Are you sure to deactivate?",
    cannotChangeLastAdmin:
      "You cannot change the role or the status of the last admin.",
    ok: "Ok",
    newManagerAssociatedSuccessfully: "New manager associated successfully.",
    teamMemberDetailsUpdatedSuccessfully:
      "Team Member details updated successfully.",

    // Messages
    noActivitiesFound: "No activities found for the selected filters/searches.",
    accessDeniedMessage: "You don't have access to perform this action.",
    productivityHelp:
      "Productivity monitoring helps track employee activities and measure performance.",
    exitFormWarning: "Are you sure you want to exit this form?",
    activityAdded: "Activity added successfully.",
    activityUpdated: "Activity updated successfully.",
    activityDeleted: "Activity deleted successfully.",
    statusUpdatedSuccessfully: "Status updated successfully.",
    technicalDifficultiesWhileUpdatingStatus:
      "It's us! There seems to be some technical difficulties while updating the status. Please try after some time.",
    noRightsToUpdateStatus:
      "Sorry, you don't have rights to update status. Please contact the HR administrator.",
    employeeStatusInactiveInCoreHR:
      "Employee status is inactive in Core HR hence you are not allowed to activate.",
    unableToUpdateMemberStatus:
      "Unable to update the member status as the member record is deleted in the same or some other user session.",
    technicalDifficultiesWhileFetchingTeamMembers:
      "It's us! There seems to be some technical difficulties while fetching the team members. Please try after some time.",

    // Email
    sendEmail: "Send Email",
    emailSubject: "Sending the attached team dashboard to myself",
    emailBody:
      "Attached is the FlowTrack productivity analytics dashboard in PDF format for your review",

    // Other
    employeeIdShort: "E-ID",
    name: "Name",
    desktopClientUnavailable:
      "Desktop client download is not available. Please contact the platform administrator.",

    // HrmsMembersList
    technicalDifficultiesWhileFetchingMembers:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    somethingWentWrongWhileFetchingMembers:
      "Something went wrong while fetching the members. Please try after some time.",
    noMatchingSearchResultsFound: "No matching search results found.",
    pleaseOnboardTeamMembersToTrackActivities:
      "Please onboard your team members to track their activities.",

    // TeamMembersAddEdit
    new: "New",
    chooseEmployeeLabel: "Choose Employee",
    pleaseSelectEmployee: "Please select employee",
    emailAddressTooltip:
      "Email address is used only for daily insights notification",
    removeManager: "Remove",
    assignComputerName: "Assign Computer Name",
    moveToStore: "Move to Store",
    formHasNoChanges: "Form has no changes",
    assetMappingRequired:
      "Asset needs to be mapped for the member record creation. Please deploy the agent on the user's system for automatic user onboarding.",
    teamMemberAddedSuccessfully: "Team member added successfully.",
    teamMemberUpdatedSuccessfully: "Team member updated successfully.",
    deactivateAccountConfirmation:
      "You are deactivating your account. Once confirmed, you will not be able to access the application(Desktop & Web). Are you sure to deactivate?",
    selectEmployee: "Select Employee",
    userOnboardingNote:
      "User should have completed the onboarding successfully in HRMS before onboarding in productivity monitoring",
    validEmployeeIdFormat:
      "Please provide a valid Employee Id.Only alphanumeric, space and symbols ( . , # + & / - ( ) : ` ' ? ) are allowed.",
    somethingWentWrongWhileUpdatingTeamMember:
      "Something went wrong while updating the team member. If you continue to see this issue, please contact the platform support team.",
    errorCheckingEmployeeIdExists:
      "Something went wrong while processing the request to check the user defined employee id exist. Please try after some time.",
    errorCheckingEmployeeIdExistsAdmin:
      "Something went wrong while checking the employeeId already exist or not. If you continue to see this issue, please contact the platform administrator.",
    errorCheckingEmployeeIdExistsTryAgain:
      "Something went wrong while checking the employeeId already exist or not. Please try after some time.",
    technicalDifficultiesWhileAddingTeamMember:
      "It's us! There seems to be some technical difficulties while adding the team member. Please try after some time.",
    somethingWentWrongWhileAddingTeamMember:
      "Something went wrong while adding the team member. If you continue to see this issue, please contact the platform administrator.",
    networkError:
      "Network error. Please check your internet connection and try again.",
    technicalDifficultiesWhileFetchingEmployees:
      "It's us! There seems to be some technical difficulties while fetching the employees. Please try after some time.",
    somethingWentWrongWhileFetchingEmployees:
      "Something went wrong while fetching the employees. If you continue to see this issue, please contact the platform administrator.",
    technicalDifficultiesWhileUpdatingTeamMember:
      "It's us! There seems to be some technical difficulties while updating the team member. Please try after some time.",
    unableToUpdateMemberDetailsEmailExists:
      "Unable update the member details as the email address was already exist.",
    employeeIdAlreadyExists: "Employee Id already exist",
    updateAccessDeniedMsg:
      "Sorry, you don't have access to update team members. Please contact your HR administrator.",
    unableToUpdateMemberDetailsRecordDeleted:
      "Unable to update the member details as the member record is deleted in the same or some other user session.",
    somethingWentWrongWhileUpdatingTeamMemberAdmin:
      "Something went wrong while updating the team member. If you continue to see this issue, please contact the platform administrator.",
    technicalDifficultiesWhileFetchingAdminsManagers:
      "It's us! There seem to be some technical difficulties retrieving administrators/managers. Please try again later.",
    employee: "Employee",
    noEmailPresent:
      "An email address is required to enable tracking. Please initiate a new invite with the email configured.",

    // Employee Insights
    noActivitiesTrackedYet: "There are no activities tracked yet for this day",
    workedHours: "Worked Hours",
    idle: "Idle",
    notActive: "Not Active",
    workedHoursInMinutes: "Worked Hours (In minutes)",
    time24HoursFormat: "Time (24 hours format)",
    activeInMins: "Active (In mins)",
    idleInMins: "Idle (In mins)",
    notActiveInMins: "Not Active (In mins)",
    workedHoursInMins: "Worked Hours (In mins)",
    technicalDifficultiesWhileFetchingInsights:
      "It's us! There seems to be some technical difficulties while fetching the employee's daily insights. Please try after some time.",
    noAccessToViewInsights:
      "Sorry, you don't have access to view your daily insights. Please contact the HR administrator.",
    somethingWentWrongFetchingInsights:
      "Something went wrong while fetching the employee's daily insights. If you continue to see this issue, please contact the platform administrator.",

    // Team Activity Dashboard
    efficiencyPro: "Efficiency Pro",
    lowActivity: "Low Activity",
    efficiencyAndFocusAreKeys: "Efficiency and focus are keys",
    toSuccess: "to success",
    technicalDifficultiesWhileFetchingData:
      "There seems to be some technical difficulties while fetching data",
    weAreWhatWeRepeatedly: "We are what we repeatedly do",
    excellenceThenIsNotAnAct: "Excellence then, is not an act, but a habit",
    top5: "Top 5",
    ofTheDay: "of the day",
    productive: "Productive",
    unproductive: "Unproductive",
    uncategorized: "Uncategorized",
    myPowersAreOrdinary: "My powers are ordinary",
    onlyMyApplicationBringsMeSuccess: "Only my application brings me success.",
    disconnectingFromOurTechnology: "Disconnecting from our technology",
    toReconnectWithOurselvesIsAbsolutelyEssential:
      "to reconnect with ourselves is absolutely essential.",
    total: "Total",
    hrs: "hrs",
    appTitle: "App Title",
    urls: "URLs",
    noActivity: "No Activity",
    pageTitle: "Page Title",
    timeSpentOnAppTitle: "Time spent on App title",
    timeSpentOnURLs: "Time spent on URLs",
    keyStrokes: "Key Strokes",
    copy: "Copy",
    categorizeApps: "Categorize apps",
    categorizeURLs: "Categorize URLs",
    noActivitiesTrackedYetForThisDay:
      "There are no activities tracked yet for this day.",
    youCanConfigureToCapture: "You can configure to capture the",
    url: "url",
    detailsBy: "details by",
    clickingHere: "clicking here.",
    applicationNameTitle: "Application Name/Title",
    processName: "Process Name",
    category: "Category",
    percentageOfTimeSpent: "Percentage of Time Spent",
    browser: "Browser",
    domainURLs: "Domain/URLs",
    recentSnap: "recent snap",
    somethingWentWrongWhileRetrievingSelectedEmployeeWorkScheduleDetails:
      "Something went wrong while retrieving selected employee's work schedule details. Please try after some time.",
    checkInCheckOut: "Check-In - Check-Out",
    systemUpTime: "System Up Time",
    userActiveTime: "User Active Time",
    computerActivities: "Computer Activities",
    idleAndNotActiveTime: "Idle & Not Active Time",
    neutral: "Neutral",
    systemProductivity: "System Productivity",

    // Hourly Activities
    activities: "Activities",
    from: "from",
    screenshots: "Screenshots",
    apps: "Apps",
    timeSpent: "Time Spent",
    percentage: "Percentage",
    domain: "Domain",
    desktopClientStatusLog: "Desktop client Status Log",
    internetStatus: "Internet Status",
    noBrowsingActivities: "There are no browsing activities",
    errorFetchingActivities:
      "Something went wrong while fetching the activities. Please try after some time.",
    technicalDifficultiesWhileFetchingActivities:
      "It's us! There seems to be some technical difficulties while fetching the activities. Please try after some time.",
    noAccessToViewHourlyActivities:
      "Sorry, you don't have access to view your hourly activities. Please contact the platform administrator.",
    errorFetchingEmployeeAppsURLsInsights:
      "Something went wrong while fetching the employee Apps/URLs insights. If you continue to see this issue, please contact the platform administrator.",
    errorFetchingActivitiesContactAdmin:
      "Something went wrong while fetching the activities. If you continue to see this issue, please contact the platform administrator.",
    noActivitiesToExport:
      "There are no activities to export the daily insights",
    timeSlot: "Time Slot",
    activityStatus: "Activity Status",
    activityDurationInMinutes: "Activity Duration (In Minutes)",
    appsTimeSpentPercentage: "Apps - Time Spent (HH:MM:SS) - Percentage (%)",
    domainTimeSpentPercentage:
      "Domain - Time Spent (HH:MM:SS) - Percentage (%)",
    workLocation: "Work Location",
    ipInfo: "Ip_Info",
    dailyActivity: "Daily Activity",

    // Team Summary
    basedOnFixedDailyWorkHoursOf: "Based on fixed daily work hours of ",
    basedOnEachEmployeeFixedDailyWorkHours:
      "Based on each employee's fixed daily work hours. Default: ",
    includesIdleAndNotActiveTime: "Includes Idle and Not Active time",
    excludesIdleAndNotActiveTime: "Excludes Idle and Not Active time",
    totalTimeSpentOnComputer: "Total time spent on the computer.",
    userActiveTimeExcludingIdleTime:
      "User active time on the computer excluding the 'Not active' and 'Idle' time.",
    noUserActivities: "No user activities",
    averagePerShift: "Average per shift",
    computerActivitiesMeasuredDetail:
      "Computer activities are measured based on user engagement on keyboard and mouse.",
    noSystemActivities: "No system activities",
    productiveTime: "Productive Time",

    // Tooltip descriptions for table headers
    systemUpTimeHoverMessage:
      "System up time are measured based on total time spent on the computer.",
    computerActivitiesDescription:
      "Computer activities are measured based on user engagement on the keyboard and mouse.",
    idleAndNotActiveTimeDescription:
      "Idle and not active time on the computer.",
    productiveTimeDescription:
      "Time spent on applications and websites classified as productive.",
    unproductiveTimeDescription:
      "Time spent on applications and websites classified as unproductive.",
    neutralTimeDescription:
      "Time spent on applications and websites which are not classified(Uncategorized).",
    userProductivityTooltipDescription:
      "User productivity percentage on productive & neutral applications and websites.",
    privacyOn: "Privacy On",
    privacyModeAlertMessage:
      "Activity data such as productivity, screenshots, and URLs cannot be reviewed in detail in private mode. For a summary report on productivity please navigate to",
    reportsLink: "reports",
    reminderEmailSubject: "Reminder to start tracking your activity for today",
    reminderEmailContent:
      "Please start tracking to record your activity so that your effort doesn't go in vain.",
    inHours: "(In Hours)",
    notifyOfflineEmployeesTooltip:
      'Notifies offline employees to start tracking their activities using the desktop application. Please select employees who are not tracking and click "Notify."',

    // System productivity help text translations
    againstFixedDailyWorkHoursConfiguredByAdmin:
      "against the fixed daily work hours configured by admin.",
    againstTotalSystemTime: "against total system time.",
    againstTotalUserActiveTime: "against total user active time.",
    systemProductivityPercentageDescription:
      "System productivity percentage ({idleNotActiveMsg}) is based on user engagement on keyboard and mouse {lastMsg}",

    // WorkforceAnalytics.vue translations
    workforceAnalytics: "Workforce Analytics",
    workload: "Workload",
    attendance: "Attendance",
    utilizationMarginTitle: "Utilization Margin",
    utilizationMarginTooltip:
      "Utilization margin is used for assessing the overwork and under utilization of team members based on the total user active time and utilization margin.",
    workScheduleLabel: "Work Schedule:",
    regularHours: "Regular Hours:",
    timezoneLabel: "Timezone:",
    days: "Days",
    hoursLabel: "Hours",
    retryButton: "Retry",
    noDataAvailableMessage: "No data available",
    noRecordsFound: "There are no records found",
    exportEmployeeBasedAnalyticalReport:
      "Export employee based analytical report",
    exportAttendanceMusterReport: "Export attendance muster report",
    tracking: "Tracking",
    tracked: "Tracked",
    notTracking: "Not Tracking",
    notTracked: "Not Tracked",
    weekOff: "Week Off",
    theValueShouldBeGreaterThan0: "The value should be greater than 0.",
    theValueShouldBeLessThanOrEqualTo:
      "The value should be less than or equal to",
    filterAppliedToWorkforceAnalyticsForContinuousAbsenceForTheLast:
      "filter applied to workforce analytics for continuous absence for the last",
    present: "Present",
    absent: "Absent",
    workforceAnalyticsAttendanceMusterReport:
      "Workforce Analytics Attendance Muster Report",
    employeeBasedWorkforceAnalyticalReport:
      "Employee Based Workforce Analytical Report",
    somethingWentWrongWhileLoadingWorkforceAnalyticsForm:
      "Something went wrong while loading workforce analytics form. Please try after some time.",

    // WorkforceAnalytics.vue data translations
    systemUpTimeValue: "System up time",
    systemUpTimeDescription: "Total time spent on the computer.",
    userActiveTimeValue: "User active time",
    userActiveTimeDescription:
      "User active time on the computer excluding the 'Not active' and 'Idle' time.",
    idleTimeValue: "Idle Time",
    idleTimeDescription:
      "User's continuous inactive time on the system based on the idle time threshold",
    computerActivityTimeValue: "Computer activity time",
    computerActivityTimeDescription:
      "Computer activity time is measured based on user engagement on keyboard and mouse.",
    userProductiveTimeValue: "User productive time",
    userProductiveTimeDescription:
      "Time spent on application and websites classified as productive.",
    continuousAbsenceValue: "Continuous absence for the last",
    continuousAbsenceDescription:
      "Within the current month, continuous absence of an employee from today.",

    // Report headers
    employeeIdHeader: "Employee ID",
    employeeNameHeader: "Employee Name",
    employeeLastNameHeader: "Employee Last Name",
    employeeFirstNameHeader: "Employee First Name",
    employeeEmailHeader: "Employee Email Address",
    managerHeader: "Manager",
    applicationHeader: "Application",
    urlHeader: "URL",
    domainHeader: "Domain",
    browserHeader: "Browser",
    timeSpentHeader: "Time Spent",
    pageTitleHeader: "Page Title",
    processNameHeader: "Process Name",
    categoryHeader: "Category",
    percentageHeader: "Percentage",
    workLocationHeader: "Work Location",
    ipInfoHeader: "IP Info",
    timeSlotHeader: "Time Slot",
    activityStatusHeader: "Activity Status",
    activityDurationInMinutesHeader: "Activity Duration (In Minutes)",
    fileNameHeader: "File Name",
    filePathHeader: "File Path",
    fileSizeHeader: "File Size",
    fileExtensionHeader: "File Extension",
    eventTypeHeader: "Event Type",
    windowTitleHeader: "Window Title",
    keyStrokesHeader: "Key Strokes",
    mouseClicksHeader: "Mouse Clicks",
    screenshotsCountHeader: "Screenshots Count",
    totalTimeWorkedHeader: "Total Time Worked",
    totalTimeWorkedInMinutesHeader: "Total Time Worked (In Minutes)",
    activityDateHeader: "Activity Date",
    checkInTimeHeader: "Check-in Time",
    checkOutTimeHeader: "Check-out Time",
    systemUpTimeHeader: "System Up Time",
    systemUpTimeInHoursHeader: "System Up Time (In Hours)",
    userActiveTimeHeader: "User Active Time",
    userActiveTimeInHoursHeader: "User Active Time (In Hours)",
    computerActivityTimeHeader: "Computer Activity Time",
    computerActivityTimeInHoursHeader: "Computer Activity Time (In Hours)",
    idleTimeHeader: "Idle Time",
    idleTimeInHoursHeader: "Idle Time (In Hours)",
    systemProductivityPercentageHeader: "System Productivity %",
    productiveTimeHeader: "Productive Time",
    productiveTimeInHoursHeader: "Productive Time (In Hours)",
    unproductiveTimeHeader: "Unproductive Time",
    neutralTimeHeader: "Neutral Time",
    userProductivityPercentageHeader: "User Productivity %",
    weekOffHeader: "Week Off",
    productiveTimeOnApps:
      "Productive time on application and websites classified as productive and neutral.",
    noProductiveActivities: "No productive activities",
    productiveAndNeutralApps:
      "(Productive and Neutral applications and websites)",
    userProductivity: "User Productivity",
    userProductivityPercentage:
      "User productivity percentage on productive & neutral applications and websites.",

    // Activity Tracker Summary
    activitySummary: "Activity Summary",
    dailyInsights: "Daily Insights",
    keyLogger: "Key Logger",
    clear: "Clear",
    // Export headers
    teamMembers: "Team Members",
    managerEmailAddress: "Manager Email Address",
    applicationName: "Application Name",
    applicationTitle: "Application Title",
    keyLogs: "Key Logs",
    activityStartTime: "Activity Start Time",
    activityEndTime: "Activity End Time",
    appTimeSpent: "App Time Spent",
    urlTimeSpent: "URL Time Spent",
    // Export file names
    appUsageSummary: "App Usage Summary",
    internetUsageSummary: "Internet Usage Summary",
    totalTimeSpent: "Total Time Spent",
    activitiesAreNotYetBeingMonitoredForThisDate:
      "Activities are not yet being monitored for this date.",
    applicationUsageForThisDateHasNotYetBeenTracked:
      "Application usage for this date has not yet been tracked.",
    internetUsageForThisDateHasNotYetBeenTracked:
      "Internet usage for this date has not yet been tracked.",
    activeTime: "Active Time",
    idleTime: "Idle Time",
    notActiveTime: "Not Active Time",
    minutes: "minutes",

    // Activity Tracker
    totalWorkedDuration: "Total worked duration:",
    noActivityText: "No Activity",
    errorViewingScreenshots:
      "Something went wrong while viewing the screenshots. Please try after some time.",
    failedToDownloadImage: "Failed to download image",

    // ListBusinessAndCollaborativeAppsCard translations
    businessAndCollaborative: "Business & Collaborative",
    applicationNameLabel: "Application Name",
    applicationType: "Application Type",
    selectAllButton: "Select All",
    noAppsMatchYourSearch: "No apps match your search",
    noAppsToList: "There are no apps to list.",
    noAppData: "No App Data",
    noEmpData: "No Emp Data",

    // Employee Onboard List Popup
    online: "Online",
    offline: "Offline",
    connected: "Connected",
    disconnected: "Disconnected",
    away: "Away",
    notify: "Notify",
    changeEmployee: "Change Employee",
    search: "Search",
    selectButton: "Select",
    avatar: "Avatar",

    // ListBusinessAndCollaborativeAppsCard translations
    businessAndCollaborativeLabel: "Business & Collaborative",
    applicationNameCardTitle: "Application Name",
    applicationTypeLabel: "Application Type",
    selectAllLabel: "Select All",
    noAppsMatchYourSearchMessage: "No apps match your search",
    noAppsToListMessage: "There are no apps to list.",
    noAppDataMessage: "No App Data",
    noEmpDataMessage: "No Emp Data",

    // Team Activity Error Messages
    errorFetchingTeamActivityDetails:
      "Something went wrong while fetching team activity details. Please try after some time.",
    technicalDifficultiesTeamActivity:
      "It's us! There seems to be some technical difficulties. Please try after some time.",

    // ActivityReportsChart translations
    activity: "Activity",
    myTeamActivityLabel: "My Team Activity",
    workedHoursLabel: "Worked Hours",
    myTeamWorkedHours: "My Team Worked Hours",
    noActivityForSelectedDay: "There is no activity for the selected day",
    technicalDifficultiesMessage:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    somethingWentWrongFetchingActivityReports:
      "Something went wrong while fetching activity reports. Please try after some time.",
    somethingWentWrongFetchingActivityReportsContactAdmin:
      "Something went wrong while fetching activity reports. If you continue to see this issue please contact system admin.",
    activityPercentageLabel: "Activity Percentage",
    time24HoursFormatLabel: "Time (24 hours format)",
    systemUpTimeLabel: "System Up Time",
    computerActivityTime: "Computer Activity Time",
    hours24HoursFormat: "Hours (24 hours format)",
    timeInMinutes: "Time (In Minutes)",
    atTime: "At ",
    hoursTime: ":00 hours",
    workedHoursChartLabel: "Worked Hours ",
    productiveHours: "Productive Hours ",

    // ActivityReportsDataTable translations
    myTeamMembers: "My Team Members",
    myActivityLabel: "My Activity",
    retryAction: "Retry",
    searchEmployee: "Search Employee",
    myTeam: "My Team",
    userActiveTimeLabel: "User Active Time",
    systemProductivityLabel: "System Productivity",
    noEmployeesMatchSearch: "No employees match your search",
    inviteTeamMembersToTrackActivities:
      "Please invite your team members to track their activities.",
    noAccessRightsToUpdateSettings:
      "You don't have permission to update this setting.",
    cannotChangeLastAdminRole:
      "You cannot change the role or the status of the last admin.",

    // MemberInactiveAlert
    memberInactiveAlertMessage:
      "Have you exported the member data from the reports module? Making a member 'Inactive' will trigger a data purge and you will not be able to recover the activity data.",
    memberInactiveAlertConfirmation:
      "Are you sure to make this member inactive?",
    continue: "Continue",

    // EmpMonitoringMembersList
    forDeleteSelectAtLeastOneRecord:
      "For Delete, you have to select atleast one records.",
    accessDeniedMsgUpdateMemberStatus:
      "Sorry, you don't have rights to update member status. Please contact system administrator.",
    noAccessRightsToViewTeamMemberDetails:
      "Sorry, you don't have access rights to view the team member details. Please contact your administrator.",
    technicalDifficultiesActivityReports:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    somethingWentWrongFetchingActivityReportsTime:
      "Something went wrong while fetching activity reports. Please try after some time.",
    somethingWentWrongFetchingActivityReportsAdmin:
      "Something went wrong while fetching activity reports. If you continue to see this issue please contact system admin.",
    somethingWentWrongFetchingActivityReportsComma:
      "Something went wrong while fetching activity reports. Please try after some time,",
    profilePic: "Avatar",
    employeeNameMembersHeader: "Members",

    // Insights.vue translations
    dateLabel: "Date",
    cancelButton: "Cancel",
    okButton: "OK",
    workScheduleTitle: "Work Schedule",
    noDataAvailableText: "No data available",
    timezoneTitle: "Timezone",

    // ActivityTrackerReports.vue translations
    allReports: "All Reports",
    insights: "Insights",
    dailyReport: "DailyReport",
    somethingWentWrongDownloadingReports:
      "Something went wrong while downloading the reports. Please try after some time.",

    // EmpListCalendarView.vue translations
    employeeTitle: "Employee",
    totalEmployeesPresent: "Total employees present",
    loading: "Loading...",
    workInProgress: "Work in Progress",
    presentStatus: "Present",
    absentStatus: "Absent",
    notTrackingStatus: "Not Tracking",
    weekOffStatus: "Week Off",
    overworked: "Overworked",
    normal: "Normal",
    underutilized: "Underutilized",

    // Days of the week
    sun: "SUN",
    mon: "MON",
    tue: "TUE",
    wed: "WED",
    thu: "THU",
    fri: "FRI",
    sat: "SAT",

    // EmployeeAnalyticalMoreDetailsCard.vue translations
    systemUpTimeDetail: "System Up Time",
    totalTimeSpentOnComputerDetail: "Total time spent on the computer.",
    idleTimeDetail: "Idle Time",
    idleTimeOnComputer: "Idle time on the computer.",
    userActiveTimeDetail: "User Active Time",
    userActiveTimeExcludingIdleTimeDetail:
      "User active time on the computer excluding the 'Not active' and 'Idle' time.",
    computerActivityTimeDetail: "Computer Activity Time",
    computerActivitiesMeasured:
      "Computer activity time is measured based on user engagement on keyboard and mouse.",
    systemProductivityDetail: "System Productivity",
    checkInCheckOutDetail: "Check In - Check Out",
    checkInOutDescription:
      "Check-in represents first user activity on the system and, Check-out represents the last user activity on the system based on the work schedule configuration",
    userProductivityDetail: "User Productivity",
    userProductivityDescription:
      "User productivity percentage is measured based on productive & neutral applications and websites against total time on app.",
    productiveLabel: "Productive",
    timeSpentOnProductiveApps:
      "Time spent on application and websites classified as productive.",
    unproductiveLabel: "Unproductive",
    timeSpentOnUnproductiveApps:
      "Time spent on application and websites classified as unproductive.",
    neutralLabel: "Neutral",
    timeSpentOnUncategorizedApps:
      "Time spent on application and websites which is not classified(Uncategorized).",
    hoursText: "hours",
    minutesText: "minutes",

    // AllReportsExportModal.vue translations
    individualOption: "Individual",
    teamOption: "Team",
    noOption: "No",
    yesOption: "Yes",

    noAccessToViewTeamActivityDetails:
      "Sorry, you don't have access to view team activity details.",
    errorFetchingTeamProductivityDetails:
      "Something went wrong while fetching team productivity details. Please try after some time.",
    technicalDifficultiesTeamProductivity:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    noAccessToViewTeamProductivityDetails:
      "Sorry, you don't have access to view team productivity details.",

    // AdditionalInsights.vue
    unknown: "Unknown",
    noInternetActivitiesTrackedYetForThisDay:
      "There are no internet activities tracked yet for this day.",
    technicalDifficultiesWhileFetchingInternetStatus:
      "It's us! There seems to be some technical difficulties while fetching the internet status. Please try after some time.",
    noAccessToViewDailyInsights:
      "Sorry, you don't have access to view your daily insights. Please contact the platform administrator.",
    errorFetchingInternetStatus:
      "Something went wrong while fetching the internet status. If you continue to see this issue, please contact the platform administrator.",
    // KeyStrokes.vue
    appsUsageDetails: "apps usage details",
    by: "by",
    technicalDifficultiesWhileFetchingApps:
      "It's us! There seems to be some technical difficulties while fetching the apps usage details. Please try after some time.",
    noAccessRightsToViewApps:
      "Sorry, you don't have access rights to view your apps details. Please contact the HR administrator.",
    errorFetchingApps:
      "Something went wrong while fetching the apps usage details. If you continue to see this issue, please contact the platform support team.",

    // Error messages
    chooseAtLeastOneRecordForResend:
      "For resend, you have to choose atleast one record",

    // AssetListCard
    macAddressLabel: "MAC Address",
    systemUserNameLabel: "System User Name",
    noAssetsToAssignForTeamMembers:
      "There are no assets to assign for team members",
    technicalDifficultiesWhileFetchingAssets:
      "It's us! There seems to be some technical difficulties while fetching the assets. Please try after some time.",
    somethingWentWrongWhileFetchingAssets:
      "Something went wrong while fetching the assets. If you continue to see this issue, please contact the platform administrator.",

    // EditAdminMembers
    cannotDeactivateEmployeeWithReportees:
      "Cannot deactivate employee with reportees: ",
    assignNewManagerBeforeDeactivation:
      "Please assign a new manager before deactivation.",
    adminsManagersDetailsUpdatedSuccessfully:
      "Admins/Managers details updated successfully.",
    technicalDifficultiesWhileAssociatingNewManager:
      "It's us! There seems to be some technical difficulties while associating the new manager. Please try after some time.",
    unableToAssociateNewManagerRecordDeleted:
      "Unable to associate new manager as the manager record is deleted in the same or some other user session.",
    unableToAssociateNewManagerOtherUserEditing:
      "Unable to associate new manager as some other user is editing this record.",
    somethingWentWrongWhileAssociatingNewManager:
      "Something went wrong while associating the new manager. If you continue to see this issue, please contact the platform support team.",
    technicalDifficultiesWhileUpdatingAdminMember:
      "It's us! There seems to be some technical difficulties while updating the admin member. Please try after some time.",
    unableUpdateAdminDetailsEmailExists:
      "Unable update the admin details as the email address was already exist.",
    unableToUpdateAdminDetailsRecordDeleted:
      "Unable to update the admin details as the admin record is deleted in the same or some other user session.",
    employeeIdAlreadyExist: "Employee Id already exist",
    somethingWentWrongWhileUpdatingAdminMember:
      "Something went wrong while updating the admin member. If you continue to see this issue, please contact the platform support team.",
    somethingWentWrongWhileUpdatingAdminMemberAdmin:
      "Something went wrong while updating the admin member. If you continue to see this issue, please contact the platform administrator.",
    provideValidEmployeeId:
      "Please provide a valid Employee Id.Only alphanumeric, space and symbols ( . , # + & / - ( ) : ` ' ? ) are allowed.",
    somethingWentWrongWhileProcessingRequest:
      "Something went wrong while processing the request to check the user defined employee id exits. Please try after some time.",
    somethingWentWrongWhileCheckingEmployeeIdAdmin:
      "Something went wrong while checking the employeeId already exist or not. If you continue to see this issue, please contact the platform administrator.",
    somethingWentWrongWhileCheckingEmployeeId:
      "Something went wrong while checking the employeeId already exist or not. Please try after some time.",
    // MembersAdminsList.vue
    adminsManagersHeader: "Admins/Managers",
    employeesHeader: "Employees",
    computerNameAdminHeader: "Computer Name",
    reportingManagerHeader: "Reporting Manager",
    roleHeader: "Role",
    operatingSystemHeader: "Operating System",
    agentVersionHeader: "Agent Version",
    employeeNameAdminHeader: "Employee Name",
    clearAllButton: "Clear All",
    addTeamMembersButton: "Add Team Members",
    bulkAddButton: "Bulk Add",
    noAdminsManagersMatchSearch: "No admins/managers match your search",
    noTeamMembersMatchSearch: "No team members match your search",
    tryAgainByChangingFilters:
      "Please try again by changing the filters or clear it to get all data.",
    okAdminButton: "Ok",
    employeeIdAdminHeader: "Employee Id",
    emailAddressHeader: "Email Address",
    managerEmailAddressHeader: "Manager Email Address",

    // Success and error messages
    employeeStatusInactive:
      "Employee status is inactive in Core HR hence you are not allowed to activate.",
    memberRecordDeleted:
      "Unable to update the member status as the member record is deleted in the same or some other user session.",
    somethingWentWrongWhileUpdatingStatus:
      "Something went wrong while updating the status. If you continue to see this issue, please contact the platform administrator.",

    // TeamMembersManualImport.vue
    addNewMembers: "Add New Members",
    reachedMaximumUserLimit: "You have reached the maximum user limit.",
    purchaseMoreLicenses: "To add more members, please purchase more licenses.",
    addLicense: "Add License",
    addAtLeastOneMemberToSave: "Add at least one member to save",
    chooseOptionToAddMembers: "Choose an option to add members",
    uploadCsvXlsWithDetails: "Upload CSV/XLS with details",
    addUsersManuallyWithDetails: "Add users manually with details",

    // TeamMembersManualImport.vue error messages
    teamMembersOnboardedSuccessfully: "Team members onboarded successfully.",
    membersOnboardedPartially: "Member(s) onboarded partially.",
    technicalDifficultiesWhileOnboardingTeamMembers:
      "It's us! There seems to be some technical difficulties while onboarding the team members. Please try after some time.",
    somethingWentWrongWhileOnboardingTeamMembers:
      "Something went wrong while onboarding the team members. If you continue to see this issue, please contact the platform administrator.",
    // MemberExceedWarningModal.vue
    exceedWarning: "exceed-warning",
    youHaveReachedMaximumUserLimit: "You have reached the maximum user limit.",
    purchaseMoreLicensesByClickingButton:
      'You have to purchase more licenses by clicking the "Add License" button below.',

    // ListManagers.vue
    searchManager: "Search Manager",
    noEmpDataText: "No Emp Data",
    noEmployeesMatchSearchText: "No employees match your search",
    clearSearch: "Clear Search",
    noManagersAvailable: "No managers available",
    profilePicText: "Profile Pic",
    somethingWentWrongWhileFetchingManagersList:
      "Something went wrong while fetching the Managers list. Please try again refreshing the page or contact platform administrator.",
    noManagersFoundMessage:
      "There are no managers found. Please add or update the members with Manager role.",

    // ChooseExportOptionsModal.vue
    import: "Import",
    manual: "Manual",
    chooseYourInviteOption: "Choose your invite option",
    bulkImportText:
      "Upload any CSV, XLS, or XLSX file with the first name, last name, email address, and role for onboarding.",
    manualImportText:
      "Add one or more users manually with details such as the first name, last name, email address, and role for onboarding.",
    shiftValidationImage: "shift validation image",

    // StealthTeamMembersMain.vue
    addTeamMembers: "Add Team Members",
    bulkAdd: "Bulk Add",
    onboardAdminsManagers: "Onboard Admins/Managers",

    screenshotsDownloadedSuccessfully: "Screenshots downloaded successfully.",
    errorDownloadingScreenshots:
      "Something went wrong while downloading screenshots. Please try again later.",
    screenshotZipRequested:
      "Preparing screenshots. Download link will be emailed to you.",
    selectScreenshotsToDownload: "Select screenshots to download",
    screenshotsSkipped:
      "{count} screenshot(s) could not be downloaded and were skipped.",
    technicalDifficultiesWhileFetchingActivitySummaries:
      "It's us! There seem to be some technical difficulties while fetching {activityCategory} activity summaries. Please try after some time.",
    technicalDifficultiesWhileFetchingAppSummaryDetails:
      "It's us! There seem to be some technical difficulties while fetching {activityCategory} app summary details. Please try after some time.",
    technicalDifficultiesWhileFetchingInternetSummaryDetails:
      "It's us! There seem to be some technical difficulties while fetching {activityCategory} internet summary details. Please try after some time.",
    noAccessRightsToViewAppSummaryDetails:
      "Sorry, you don't have access rights to view {activityCategory} app summary details.",
    noAccessRightsToViewInternetSummaryDetails:
      "Sorry, you don't have access rights to view {activityCategory} internet summary details.",
    somethingWentWrongWhileFetchingActivitySummary:
      "Something went wrong while fetching {activityCategory} activity summary. Please try after some time.",
    somethingWentWrongWhileFetchingAppSummaryDetails:
      "Something went wrong while fetching {activityCategory} app summary details. Please try after some time.",
    somethingWentWrongWhileFetchingInternetSummaryDetails:
      "Something went wrong while fetching {activityCategory} internet summary details. Please try after some time.",
    somethingWentWrongWhileFetchingActivitySummaryContactAdmin:
      "Something went wrong while fetching {activityCategory} activity summary. If you continue to see this issue, please contact the platform administrator.",
    somethingWentWrongWhileFetchingAppSummaryDetailsContactAdmin:
      "Something went wrong while fetching {activityCategory} app summary details. If you continue to see this issue, please contact the platform administrator.",
    somethingWentWrongWhileFetchingInternetSummaryDetailsContactAdmin:
      "Something went wrong while fetching {activityCategory} internet summary details. If you continue to see this issue, please contact the platform administrator.",
    selectToDownload: "Select to download the screenshots",
    previewInScreenshots: "Image can be previewed in screenshots tab",
    technicalDifficultiesWhileFetchingEmployeeRoles:
      "It's us! There seems to be some technical difficulties while fetching the employee roles. Please try after some time.",
    technicalDifficultiesWhileFetchingEmployeeRolesContactAdmin:
      "Something went wrong while fetching the employee roles. If you continue to see this issue, please contact the platform administrator.",
    of: "of",

    // Additional report headers for AllReportsExportModal
    checkinDateTimeHeader: "Checkin Date & Time",
    checkoutDateTimeHeader: "Checkout Date & Time",
    trackingStatusHeader: "Tracking Status",
    totalSystemUpTimeHeader: "Total System Up Time",
    totalUserActiveTimeHeader: "Total User Active Time",
    userActiveTimeKeyboardMouseHeader:
      "User Active Time Spent on Keyboard & Mouse",
    timeSpentIdleNotActiveHeader: "Time Spent on Idle & Not Active",
    systemProductivityIncludesIdleHeader:
      "System Productivity % (Includes Idle & Not Active Time)",
    systemProductivityExcludesIdleHeader:
      "System Productivity % (Excludes Idle & Not Active Time)",
    timeZoneHeader: "Time Zone",
    attendanceSessionTimeHeader: "Attendance Session Time",
    attendanceSessionTimeMinutesHeader: "Attendance Session Time (In Minutes)",
    systemProductivityFixedHoursHeader:
      "System Productivity % (Based on Fixed Daily Work Hours)",
    totalIdleTimeHeader: "Total Idle Time",
    totalIdleTimeMinutesHeader: "Total Idle Time (In Minutes)",
    totalNotActiveTimeHeader: "Total Not Active Time",
    totalNotActiveTimeMinutesHeader: "Total Not Active Time (In Minutes)",
    timeSpentIdleNotActiveMinutesHeader:
      "Time Spent on Idle & Not Active (In Minutes)",
    totalSystemUpTimeMinutesHeader: "Total System Up Time (In Minutes)",
    totalUserActiveTimeMinutesHeader: "Total User Active Time (In Minutes)",
    userActiveTimeKeyboardMouseMinutesHeader:
      "User Active Time Spent on Keyboard & Mouse (In Minutes)",
    totalSystemActiveTimeWithoutLockAppHeader:
      "Total System Active Time Without Lock App",
    totalSystemActiveTimeWithoutLockAppMinutesHeader:
      "Total System Active Time Without Lock App (In Minutes)",
    totalLockAppTimeHeader: "Total Lock App Time",
    totalLockAppTimeMinutesHeader: "Total Lock App Time (In Minutes)",
  },
  sp: {
    /* ----- Spanish Translations ----- */
    // Section titles and Report headers
    productivityReports: "Informes de Productividad",
    analyticalReports: "Informes Analíticos",
    summaryReports: "Informes de Resumen",
    dlpReports: "Informes de Prevención de Pérdida de Datos (DLP)",
    locationIntelligence: "Inteligencia de Ubicación",
    assetReport: "Informe de Activos",

    // Report headers and content
    timeActivityReport: "Informe de Tiempo y Actividad",
    timeActivityReportContent:
      "Generar informes de tiempo activo y productivo.",
    attendanceReport: "Informe de Asistencia",
    attendanceReportContent:
      "Generar informes de asistencia con hora de entrada/salida junto con el tiempo activo total y el tiempo productivo.",
    appsReport: "Informe de Aplicaciones",
    appsReportContent:
      "Generar informes de uso de aplicaciones durante las horas activas.",
    appsTitleReport: "Informe de Título de Aplicaciones",
    urlsReport: "Informe de URLs",
    urlsReportContent:
      "Generar informes de uso de URLs durante las horas activas.",
    productiveAppsReport: "Informe de Aplicaciones Productivas",
    productiveAppsReportContent:
      "Generar informes de uso de aplicaciones productivas durante las horas activas.",
    productiveURLsReport: "Informe de URLs Productivas",
    productiveURLsReportContent:
      "Generar informes de uso de URLs productivas durante las horas activas.",
    consolidatedAppsURLsReport: "Informe Consolidado de Aplicaciones y URLs",
    consolidatedAppsURLsReportContent:
      "Generar informes de uso consolidado de aplicaciones y URLs durante las horas activas.",
    efficiencyReport: "Informe de Eficiencia",
    efficiencyReportContent:
      "Generar informes para miembros del equipo altamente eficientes.",
    lowActivityReport: "Informe de Baja Actividad",
    lowActivityReportContent:
      "Generar informes de baja actividad durante las horas laborales.",
    productivitySummaryReport: "Informe Resumen de Productividad",
    productivitySummaryReportContent:
      "Generar informes de actividades de usuario de productividad en todas las métricas por día.",
    productiveUnproductiveSummaryReport:
      "Informe Resumen de Productivo e Improductivo",
    productiveUnproductiveSummaryReportContent:
      "Generar informes para actividades de usuario productivas e improductivas en todas las métricas por día",
    productiveAppsMetric: "Métrica de Aplicaciones Productivas",
    productiveAppsMetricContent:
      "Generar informes para aplicaciones productivas con volumen de usuario único.",
    productiveURLsMetric: "Métrica de URLs Productivas",
    productiveURLsMetricContent:
      "Generar informes para URLs productivas con volumen de usuario único.",
    unproductiveAppsMetrics: "Métricas de Aplicaciones Improductivas",
    unproductiveAppsMetricsContent:
      "Generar informes con aplicaciones improductivas y sin categorizar con volumen de usuario único.",
    unproductiveURLsMetric: "Métrica de URLs Improductivas",
    unproductiveURLsMetricContent:
      "Generar informes con URLs improductivas y sin categorizar con volumen de usuario único.",
    monthlySummaryReport: "Informe Resumen Mensual",
    monthlySummaryReportContent:
      "Generar un informe resumen de la actividad del usuario en el ordenador y software.",
    weeklySummaryReport: "Informe Resumen Semanal",
    weeklySummaryReportContent:
      "Generar un informe resumen de la actividad del usuario en el ordenador y software.",
    fileWebFileEventSummaryReport:
      "Informe Resumen de Eventos de Archivo y Archivo Web",
    fileWebFileEventSummaryReportContent:
      "Generar un informe resumen de la actividad del usuario en eventos de archivo web y archivo.",
    fileEventReport: "Informe de Eventos de Archivo",
    fileEventReportContent:
      "Generar un informe de la actividad del usuario en eventos de archivo.",
    webFileEventReport: "Informe de Eventos de Archivo Web",
    webFileEventReportContent:
      "Generar un informe de la actividad del usuario en eventos de archivo web.",
    locationIntelligenceReport: "Informe de Inteligencia de Ubicación",
    locationIntelligenceReportContent:
      "Generar un informe de la actividad del usuario basado en su ubicación",
    locationIntelligenceMonthlySummaryReport:
      "Informe Resumen Mensual de Inteligencia de Ubicación",
    locationIntelligenceMonthlySummaryReportContent:
      "Generar un informe de la actividad del usuario basado en su ubicación",
    assetReportHeader: "Informe de Activos",
    usersInCoreHrNote: "Usuarios en Core HR",
    inviteInitiatedFor: "Invitación iniciada para",
    membersSuccessfully: "miembro(s) con éxito",
    checkInviteesStatusInInvitesTab:
      "Verificar el estado de los invitados en la pestaña de invitaciones",
    resendInvitationInitiatedSuccessfully:
      "Reenvío de invitación iniciado con éxito",
    assetReportContent:
      "Generar informe de activos con dirección mac, sistema operativo y detalles del usuario.",

    // Export related
    export: "Exportar",
    exportButton: "Exportar",
    exportAction: "Exportar",
    editColumns: "Editar Columnas",
    columnConfigurationSavedSuccessfully:
      "Configuración de columnas guardada con éxito",
    errorSavingColumnConfiguration:
      "Error al guardar la configuración de columnas",
    employeeId: "ID de Empleado",
    employeeFirstName: "Nombre del Empleado",
    employeeLastName: "Apellido del Empleado",
    systemUserName: "Nombre de Usuario del Sistema",
    employeeEmail: "Dirección de Correo Electrónico del Empleado",
    manager: "Gerente",
    department: "Departamento",
    designation: "Designación",
    serialNumber: "Número de Serie",
    macAddress: "Dirección MAC",
    computerName: "Nombre del Ordenador",
    assetType: "Tipo de Activo",
    operatingSystem: "Sistema Operativo",
    agentVersion: "Versión del Agente",
    status: "Estado",
    noAccessToAddLicenses: "La facturación automática no es aplicable.",

    // Error messages
    technicalDifficultiesExportingReport:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al exportar el informe. Por favor, inténtelo después de un tiempo.",
    noAccessRightsToViewReports:
      "Lo sentimos, no tiene derechos de acceso para ver informes. Por favor, contacte a su administrador",
    somethingWentWrongExportingReport:
      "Algo salió mal al exportar el informe. Si continúa viendo este problema, por favor contacte al administrador de la plataforma.",
    technicalDifficultiesSource:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los detalles de {source}. Por favor, inténtelo después de un tiempo.",
    noAccessRights:
      "Lo sentimos, no tiene derechos de acceso para ver los detalles de {source}. Por favor, contacte al administrador de RRHH.",
    somethingWentWrong:
      "Algo salió mal al obtener los detalles de {source}. Si continúa viendo este problema, por favor contacte al equipo de soporte de la plataforma.",
    appsUsage: "uso de aplicaciones",

    // AllReportsExportModal translations
    reportFileFormat: "Formato de Archivo del Informe",
    reportHeaders: "Encabezados del Informe",
    show: "Mostrar",
    change: "Cambiar",
    excludeWeekOff: "Excluir Días Libres",
    reportFor: "Informe Para",
    select: "Seleccionar",
    viewAll: "Ver Todos",
    appsType: "Tipo de Aplicaciones",
    organizationLevelBenchmark:
      'El nivel de organización, "{settingsType}", se utilizará como punto de referencia para el resultado del informe.',
    noSearchResultsFound: "No se encontraron resultados de búsqueda",
    save: "Guardar",
    chooseEmployee: "Elegir Empleado",
    xlsx: "XLSX",
    csv: "CSV",
    individual: "Individual",
    team: "Equipo",
    no: "No",
    yes: "Sí",
    all: "Todos",
    business: "Negocios",
    collaborative: "Colaborativo",
    yesterday: "Ayer",
    last7Days: "Últimos 7 días",
    lastWeek: "Última semana",
    last2Weeks: "Últimas 2 semanas",
    thisMonth: "Este mes",
    lastMonth: "Mes pasado",
    activityGoalsSettings: "Configuración de Objetivos de Actividad",
    appsAndURLsSettings: "Configuración de Aplicaciones y URLs",
    noDataAvailableForSelectedCriteria:
      "No hay datos disponibles para los criterios seleccionados. Por favor, intente con un rango de fechas diferente.",
    noDataAvailableForSelectedPeriod:
      "No hay datos disponibles para el período seleccionado. Por favor, intente con un rango de fechas diferente.",
    exportReportFor31DaysOrLess:
      "Por favor, exporte el informe para 31 días o menos",
    exportReportFor7DaysOrLess:
      "Por favor, exporte el informe para 7 días o menos",

    // Other translations
    addNewMembers: "Añadir Nuevos Miembros",
    networkError:
      "Error de red. Por favor, compruebe su conexión a Internet e inténtelo de nuevo.",
    technicalDifficultiesWhileFetchingTeamMembers:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los miembros del equipo. Por favor, inténtelo después de un tiempo.",

    // New translations
    deactivateAccountConfirmation:
      "Estás desactivando tu cuenta. Una vez confirmado, no podrás acceder a la aplicación (Escritorio y Web). ¿Estás seguro de desactivar?",
    validEmployeeIdFormat:
      "Por favor, proporciona un ID de empleado válido. Solo se permiten alfanuméricos, espacios y símbolos ( . , # + & / - ( ) : ` ' ? ).",
    errorCheckingEmployeeIdExists:
      "Algo salió mal al procesar la solicitud para verificar si existe el ID de empleado definido por el usuario. Por favor, inténtalo después de un tiempo.",
    errorCheckingEmployeeIdExistsAdmin:
      "Algo salió mal al verificar si el ID de empleado ya existe o no. Si continúas viendo este problema, comunícate con el administrador de la plataforma.",
    errorCheckingEmployeeIdExistsTryAgain:
      "Algo salió mal al verificar si el ID de empleado ya existe o no. Por favor, inténtalo después de un tiempo.",
    technicalDifficultiesWhileAddingTeamMember:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al agregar el miembro del equipo. Por favor, inténtalo después de un tiempo.",
    somethingWentWrongWhileAddingTeamMember:
      "Algo salió mal al agregar el miembro del equipo. Si continúas viendo este problema, comunícate con el administrador de la plataforma.",
    technicalDifficultiesWhileFetchingEmployees:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los empleados. Por favor, inténtalo después de un tiempo.",
    somethingWentWrongWhileFetchingEmployees:
      "Algo salió mal al obtener los empleados. Si continúas viendo este problema, comunícate con el administrador de la plataforma.",
    technicalDifficultiesWhileUpdatingTeamMember:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al actualizar el miembro del equipo. Por favor, inténtalo después de un tiempo.",
    unableToUpdateMemberDetailsEmailExists:
      "No se puede actualizar los detalles del miembro ya que la dirección de correo electrónico ya existe.",
    employeeIdAlreadyExists: "El ID de empleado ya existe",
    unableToUpdateMemberDetailsRecordDeleted:
      "No se puede actualizar los detalles del miembro ya que el registro del miembro se eliminó en la misma u otra sesión de usuario.",
    somethingWentWrongWhileUpdatingTeamMember:
      "Algo salió mal al actualizar el miembro del equipo. Si continúas viendo este problema, comunícate con el equipo de soporte de la plataforma.",
    somethingWentWrongWhileUpdatingTeamMemberAdmin:
      "Algo salió mal al actualizar el miembro del equipo. Si continúas viendo este problema, comunícate con el administrador de la plataforma.",
    technicalDifficultiesWhileFetchingAdminsManagers:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los administradores/gerentes. Por favor, inténtelo después de un tiempo.",
    employee: "Empleado",
    selectEmployee: "Seleccionar Empleado",
    formHasNoChanges: "El formulario no tiene cambios",
    assetMappingRequired:
      "Es necesario mapear un activo para la creación del registro de miembro. Por favor, implemente el agente en el sistema del usuario para la incorporación automática del usuario.",
    teamMemberAddedSuccessfully: "Miembro del equipo añadido con éxito.",
    teamMemberUpdatedSuccessfully: "Miembro del equipo actualizado con éxito.",
    noEmailPresent:
      "Se requiere una dirección de correo electrónico para habilitar el seguimiento. Por favor, inicie una nueva invitación con el correo configurado.",
    /* ----- Productivity Monitoring ----- */
    // Section titles
    teamActivityDashboard: "Panel de Actividad del Equipo",
    myActivityDashboard: "Panel de Mi Actividad",
    productivityMonitoring: "Monitoreo de Productividad",
    activityTracker: "Rastreador de Actividad",
    myActivity: "Mi Actividad",
    myTeamActivity: "Actividad de Mi Equipo",
    members: "Miembros",

    // Team Members
    licenses: "Licencias",
    add: "Añadir",
    invite: "Invitar",
    invites: "Invitaciones",
    invited: "Invitado",
    purchased: "Comprado",
    assigned: "Asignado",
    available: "Disponible",
    resendInvite: "Reenviar Invitación",
    inviteMembers: "Invitar Miembros",
    onboardMembers: "Incorporar Miembros",
    adminsManagers: "Administradores/Gerentes",
    employees: "Empleados",
    invitedDate: "Fecha de Invitación",
    exportAdminsManagers: "Exportar Administradores/Gerentes",
    exportMembers: "Exportar Miembros",
    inviteAdminsManagers: "Invitar Administradores/Gerentes",
    addAtLeastOneUserToInvite: "Añadir al menos un usuario para invitar",
    inviteNewAdminsManagers: "Invitar a Nuevos Administradores/Gerentes",
    addAccessDeniedMsg:
      "Lo sentimos, no tienes acceso para añadir miembros. Por favor, contacta a tu administrador de RRHH.",
    inviteAdminsManagersTrackActivities:
      "Por favor, invita a tus administradores/gerentes y rastrea sus actividades",
    inviteTeamMembersTrackActivity:
      "Por favor, invita a los miembros de tu equipo y rastrea la actividad de los miembros de tu equipo",
    noAccessToInvite:
      "Lo sentimos, no tienes acceso para invitar a ningún miembro. Por favor, contacta al administrador del sistema.",
    resendInviteTooltip: "Para reenviar, debes elegir al menos un registro.",
    noRightsToResendInvite:
      "Lo sentimos, no tienes derechos para reenviar invitaciones. Por favor, contacta a tu administrador.",
    noAccessToUpdateMembers:
      "Lo sentimos, no tienes acceso para actualizar los miembros del equipo. Por favor, contacta a tu administrador de RRHH.",
    pleaseInviteAdminsManagersAndTrack:
      "Por favor, invite a sus administradores/gerentes y supervise sus actividades.",

    // Member Details
    employeeIdDetail: "ID de Empleado",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo Electrónico",
    departmentDetail: "Departamento",
    designationDetail: "Designación",
    reportingManager: "Gerente de Informes",
    operatingSystemDetail: "Sistema Operativo",
    agentVersionDetail: "Versión del Agente",
    statusDetail: "Estado",
    // Activity Tracker tabs
    activityTrackerTab1: "Rastreador de Actividad",
    activityTrackerTab2: "Mi Actividad",
    activityTrackerTab3: "Actividad de Mi Equipo",
    activityTrackerTab4: "Miembros",
    activityTrackerTab5: "Panel de Actividad del Equipo",
    activityTrackerTab6: "Panel de Mi Actividad",
    activityTrackerTab7: "Panel CXO",

    // Employee Data Management tabs
    employeeDataManagementTab1: "Datos del Empleado",
    employeeDataManagementTab2: "Cuentas de Usuario",
    employeeDataManagementTab3: "Firmantes",
    employeeDataManagementTab4: "Acreditación",

    // Dashboard sections
    overview: "Resumen",
    employeeProductivity: "Productividad del Empleado",
    departmentPerformance: "Rendimiento del Departamento",
    timeTracking: "Seguimiento de Tiempo",

    // Table headers
    employeeName: "Nombre del Empleado",
    departmentHeader: "Departamento",
    activityLevel: "Nivel de Actividad",
    timeTracked: "Tiempo Registrado",
    startTime: "Hora de Inicio",
    endTime: "Hora de Fin",
    duration: "Duración",
    statusHeader: "Estado",
    trackingStatus: "Estado de Seguimiento",
    userStatus: "Estado del Usuario",
    actions: "Acciones",
    utilizationMargin: "Margen de Utilización",

    // Dashboard metrics
    totalEmployees: "Total de Empleados",
    activeEmployees: "Empleados Activos",
    averageProductivity: "Productividad Promedio",
    productivityScore: "Puntuación de Productividad",
    topPerformers: "Mejores Rendimientos",
    lowPerformers: "Rendimientos Bajos",
    productivityTrend: "Tendencia de Productividad",
    hoursWorked: "Horas Trabajadas",
    activeDuration: "Duración Activa",
    idleDuration: "Duración Inactiva",
    timeInHours: "Tiempo en horas",
    totalTimeInHours: "Tiempo total en horas",
    productivityTrendPeriod:
      "Tendencia de productividad durante un período determinado",
    workedToday: "Trabajado Hoy",
    todaysActivity: "Actividad de Hoy",
    workedThisWeek: "Trabajado esta Semana",
    weeklyActivity: "Actividad Semanal",
    myTeamWeeklyActivity: "Actividad Semanal de Mi Equipo",
    myWeeklyActivity: "Mi Actividad Semanal",
    technicalDifficulties:
      "Parece que hay algunas dificultades técnicas al obtener datos",
    numberOfEmployees: "Número de Empleados",
    high: "Alto",
    moderate: "Moderado",
    low: "Bajo",
    activityPercentage: "Porcentaje de Actividad",
    activityData: "Datos de Actividad",
    topAppsAndUrls: "Principales Aplicaciones y URLs de la semana",
    focusOnSocial: "Concéntrate en cómo ser social,",
    notOnHowToDoSocial: "no en cómo hacer social.",
    topAppsOfWeek: "Principales Aplicaciones de la semana",
    topUrlsOfWeek: "Principales URLs de la semana",
    topAppsOfDay: "Las 5 mejores aplicaciones del día",
    topUrlsOfDay: "Los 5 mejores URLs del día",
    hours: "Horas",
    recentScreenshots: "Capturas de Pantalla Recientes",
    viewAllLink: "ver todo",
    weaponsDangerous: "Las armas son peligrosas",
    wordsArePowerful:
      "Las palabras son poderosas. ¡Y las capturas de pantalla también!",

    // Location types
    officeRemote: "Oficina/Remoto",
    office: "Oficina",
    remote: "Remoto",
    allFilter: "Todos",

    // Filter labels
    dateRange: "Rango de Fechas",
    activityType: "Tipo de Actividad",

    // Buttons and actions
    addNew: "Añadir Nuevo",
    resetFilterSearch: "Restablecer Filtro/Búsqueda",
    edit: "Editar",
    view: "Ver",
    delete: "Eliminar",
    close: "Cerrar",
    saveButton: "Guardar",
    submit: "Enviar",
    cancel: "Cancelar",
    back: "Volver",
    changeButton: "Cambiar",
    download: "Descargar",
    downloadClient: "Descargar Cliente",
    send: "Enviar",
    shareDashboard: "Compartir Panel",
    privacy: "Privacidad",
    date: "Fecha",
    workSchedule: "Horario de Trabajo",
    timezone: "Zona Horaria",
    myDefaultView: "Mi Vista Predeterminada",
    selectManager: "Seleccionar Gerente",
    managerLabel: "Gerente",
    noDataAvailable: "No hay datos disponibles",
    to: "Para",
    body: "Cuerpo",
    skip: "Omitir",
    next: "Siguiente",
    inviteLater: "Invitar Más Tarde",
    version: "Versión",

    // Admin Activation Screen
    introducing: "Presentando",
    welcomeTo: "Bienvenido a",
    productivityMonitoringSolution:
      "Solución de Monitoreo de Productividad totalmente integrada para rastrear la actividad del empleado en tiempo casi real. Puede configurar para capturar capturas de pantalla aleatorias con una opción para difuminarlas. La productividad de su equipo se mide en función de su actividad en el teclado y el ratón.",
    noRightsToActivateAccount:
      "No tiene derechos para activar su cuenta. Por favor contacte a su administrador.",
    learnMore: "Más Información",

    // Core User Invited Screen
    inviteAcceptanceMessage:
      'Se le ha enviado una invitación para su aceptación. Por favor revise su bandeja de entrada. Si no recibió el correo electrónico de aceptación, haga clic en el botón "solicitar acceso" para reenviar la invitación.',
    requestAccess: "Solicitar Acceso",

    // Core User Not Invited Screen
    assistsTrackingTimeProductivity:
      "Le ayuda a realizar un seguimiento del tiempo y la productividad.",

    // EmpMonitorIntroScreen2
    howDoYouLikeToTrackUserActivities:
      "¿Cómo le gustaría realizar el seguimiento de las actividades del usuario?",
    consentBased: "Basado en Consentimiento",
    stealthMode: "Modo Sigiloso",
    consentBasedTrackingDescription:
      "El seguimiento basado en consentimiento ayuda a los empleados a decidir cuándo les gustaría iniciar y detener el seguimiento. Obtener el consentimiento informado voluntario de todos sus empleados es el mejor resultado posible, pero el seguimiento basado en consentimiento está reservado para un mundo perfecto en el que no vivimos ahora.",
    stealthModeTrackingDescription:
      "El seguimiento en modo sigiloso habilita el modo oculto y comienza a funcionar automáticamente cuando el usuario activa su PC. No interfiere con el trabajo del usuario y proporciona información crucial sobre su productividad.",
    technicalDifficultiesTrackingMode:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al elegir el modo de seguimiento de su aplicación de seguimiento de actividad. Por favor, inténtelo después de un tiempo.",
    errorChoosingTrackingMode:
      "Algo salió mal al elegir el modo de seguimiento de su aplicación de seguimiento de actividad. Si continúa viendo este problema, póngase en contacto con el administrador de la plataforma.",

    // EmpMonitorIntroScreen3
    downloadDesktopAgentHere: "Descargue el agente de escritorio aquí",
    downloadDesktopClientHere:
      "Descargue el cliente de escritorio aquí, según su sistema operativo",
    watchVideoTutorialFor: "Por favor, vea el tutorial en video aquí para",
    osDesktop: "SO escritorio",
    installationAndOperationalFlow: "instalación y su flujo operativo.",
    assetAndEmployeeOnboardingFlow:
      "Flujo de incorporación de activos y empleados",
    step1: "Paso 1",
    step2: "Paso 2",
    step3: "Paso 3",
    step4: "Paso 4",
    step5: "Paso 5",
    downloadTheAgent: "Descargar el agente",
    installAgentOnEndpoint: "Instalar el agente en el punto final a monitorear",
    endpointsScannedAssetDetails:
      "Los puntos finales se escanean y los detalles del activo, como la dirección Mac, el nombre de la computadora, el sistema operativo y la versión del agente, se envían al registro de activos en la nube",
    associateOwnerToAsset:
      "Asociar propietario (Empleado) al activo en la aplicación en la nube",
    keystrokesMouseAppsMonitored:
      "Las pulsaciones de teclas, el ratón, las aplicaciones y el uso de Internet se monitorean con capturas de pantalla aleatorias",
    desktopDownloadNotAvailable:
      "La descarga de {0} de escritorio no está disponible. Por favor, póngase en contacto con el administrador de la plataforma.",
    unableToDownloadApplication:
      "No se puede descargar la aplicación. ¿Le importaría intentarlo después de un tiempo o contactar al administrador del sistema?",

    // EmpMonitorIntroScreen4
    onboardYourTeam: "Incorpore a su equipo",
    fewStepsAwayToStartMonitoring:
      "Está a pocos pasos de comenzar a monitorear la productividad del equipo.",
    watchVideoTutorialToLearnHowToOnboard:
      "Por favor, vea el tutorial en video para aprender cómo incorporar a los miembros de su equipo.",
    noRightsToInviteMembers:
      "No tiene derechos para invitar a miembros al rastreador de actividad. Por favor, contacte a su administrador.",

    // EmpMonitorTimeZonePopup
    timeZone: "Zona Horaria",
    timeZoneLabel: "Zona Horaria",
    activityTrackerSummarises:
      "El rastreador de actividad resume todos los esfuerzos en días, semanas y meses según la zona horaria de la Organización. Estos datos agregados se utilizan luego para informes y otras estadísticas.",
    technicalDifficultiesWhileUpdatingTimezone:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al actualizar la zona horaria. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileUpdatingTimezone:
      "Algo salió mal al actualizar la zona horaria. ¿Le importaría intentarlo de nuevo?",

    // EmpOnboardInvitesDataTable
    selectAll: "Seleccionar Todo",
    noEmployeesMatchYourSearch: "Ningún empleado coincide con su búsqueda",
    role: "Rol",
    resend: "Reenviar",
    retry: "Reintentar",
    pleaseInviteYourTeamMembers:
      "Por favor, invite a los miembros de su equipo para rastrear sus actividades.",
    exportInvitees: "Exportar Invitados",
    memberInvitees: "Miembros Invitados",
    emailAddress: "Dirección de Correo Electrónico",
    proceed: "Proceder",
    areYouSureToDeleteTheInvitedMember:
      "¿Está seguro de eliminar al miembro invitado?",

    // EditTeamMembers
    chooseManager: "Elegir Gerente",
    active: "Activo",
    inactive: "Inactivo",
    pending: "Pendiente",
    currently: "Actualmente",
    hasGot: "tiene",
    employeesAsDirectReportees:
      "empleados como subordinados directos. Por favor, elija un nuevo gerente para todos los empleados antes de cambiar el rol.",
    cannotDeactivateEmployee:
      "No puede desactivar al empleado en este momento.",
    isManagerHavingDirectReportees:
      "es un gerente que tiene subordinados directos. Por favor, cambie el rol del empleado a miembro del equipo y asigne un nuevo gerente para todos los subordinados antes de la desactivación.",
    deactivatingAccountConfirmation:
      "Está desactivando su cuenta. Una vez confirmado, no podrá acceder a la aplicación (Escritorio y Web). ¿Está seguro de desactivar?",
    cannotChangeLastAdmin:
      "No puede cambiar el rol o el estado del último administrador.",
    ok: "Aceptar",
    newManagerAssociatedSuccessfully: "Nuevo gerente asociado con éxito.",
    teamMemberDetailsUpdatedSuccessfully:
      "Detalles del miembro del equipo actualizados con éxito.",

    // Messages
    noActivitiesFound:
      "No se encontraron actividades para los filtros/búsquedas seleccionados.",
    accessDeniedMessage: "No tienes acceso para realizar esta acción.",
    productivityHelp:
      "El monitoreo de productividad ayuda a rastrear las actividades de los empleados y medir el rendimiento.",
    exitFormWarning: "¿Estás seguro de que quieres salir de este formulario?",
    activityAdded: "Actividad añadida con éxito.",
    activityUpdated: "Actividad actualizada con éxito.",
    activityDeleted: "Actividad eliminada con éxito.",
    statusUpdatedSuccessfully: "Estado actualizado con éxito.",
    technicalDifficultiesWhileUpdatingStatus:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al actualizar el estado. Por favor, inténtelo después de un tiempo.",
    noRightsToUpdateStatus:
      "Lo sentimos, no tienes derechos para actualizar el estado. Por favor, contacta al administrador de RRHH.",
    employeeStatusInactiveInCoreHR:
      "El estado del empleado está inactivo en Core HR, por lo tanto, no se te permite activarlo.",
    unableToUpdateMemberStatus:
      "No se puede actualizar el estado del miembro ya que el registro del miembro se eliminó en la misma sesión de usuario o en otra.",
    somethingWentWrongWhileUpdatingStatus:
      "Algo salió mal al actualizar el estado. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",

    // Email
    sendEmail: "Enviar correo electrónico",
    emailSubject: "Enviando el panel de control del equipo adjunto a mí mismo",
    emailBody:
      "Adjunto está el panel de análisis de productividad de FlowTrack en formato PDF para su revisión",

    // Other
    employeeIdShort: "E-ID",
    name: "Nombre",
    desktopClientUnavailable:
      "La descarga del cliente de escritorio no está disponible. Póngase en contacto con el administrador de la plataforma.",

    // TeamMembersAddEdit
    new: "Nuevo",
    chooseEmployeeLabel: "Elegir Empleado",
    pleaseSelectEmployee: "Por favor, selecciona un empleado",
    emailAddressTooltip:
      "La dirección de correo electrónico se utiliza solo para notificaciones de información diaria",
    removeManager: "Eliminar",
    assignComputerName: "Asignar Nombre de Ordenador",
    moveToStore: "Mover al Almacén",
    deactivatingAccountWarning:
      "Estás desactivando tu cuenta. Una vez confirmado, no podrás acceder a la aplicación (Escritorio y Web). ¿Estás seguro de desactivar?",
    userOnboardingNote:
      "El usuario debe haber completado con éxito la incorporación en HRMS antes de incorporarse al monitoreo de productividad",
    provideValidEmployeeId:
      "Por favor, proporciona un ID de empleado válido. Solo se permiten caracteres alfanuméricos, espacios y símbolos ( . , # + & / - ( ) : ` ' ? ).",
    somethingWentWrongWhileProcessingRequest:
      "Algo salió mal al procesar la solicitud para verificar si existe el ID de empleado definido por el usuario. Por favor, inténtalo después de un tiempo.",
    somethingWentWrongWhileCheckingEmployeeId:
      "Algo salió mal al verificar si el ID de empleado ya existe o no. Si continúas viendo este problema, por favor contacta al administrador de la plataforma.",
    somethingWentWrongWhileCheckingEmployeeIdTryLater:
      "Algo salió mal al verificar si el ID de empleado ya existe o no. Por favor, inténtalo después de un tiempo.",
    updateAccessDeniedMsg:
      "Lo sentimos, no tienes acceso para actualizar los miembros del equipo. Por favor, contacta a tu administrador de RRHH.",

    // Employee Insights
    noActivitiesTrackedYet: "No hay actividades registradas para este día",
    workedHours: "Horas trabajadas",
    idle: "Inactivo",
    notActive: "No activo",
    workedHoursInMinutes: "Horas trabajadas (En minutos)",
    time24HoursFormat: "Hora (formato 24 horas)",
    systemUpTime: "Tiempo de actividad del sistema",
    activeInMins: "Activo (En mins)",
    idleInMins: "Inactivo (En mins)",
    notActiveInMins: "No activo (En mins)",
    workedHoursInMins: "Horas trabajadas (En mins)",
    technicalDifficultiesWhileFetchingInsights:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los conocimientos diarios del empleado. Por favor, inténtelo después de un tiempo.",
    noAccessToViewInsights:
      "Lo sentimos, no tiene acceso para ver sus conocimientos diarios. Por favor, contacte al administrador de HR.",
    somethingWentWrongFetchingInsights:
      "Algo salió mal al obtener los conocimientos diarios del empleado. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",

    // Activity Tracker
    totalWorkedDuration: "Duración total trabajada:",
    noActivityText: "Sin Actividad",
    errorViewingScreenshots:
      "Algo salió mal al ver las capturas de pantalla. Por favor, inténtelo después de un tiempo.",
    failedToDownloadImage: "Error al descargar la imagen",

    // Team Activity Dashboard
    efficiencyPro: "Eficiencia Pro",
    lowActivity: "Actividad Baja",
    efficiencyAndFocusAreKeys: "La eficiencia y el enfoque son las claves",
    toSuccess: "para el éxito",
    technicalDifficultiesWhileFetchingData:
      "Parece que hay algunas dificultades técnicas al obtener datos",
    weAreWhatWeRepeatedly: "Somos lo que hacemos repetidamente",
    excellenceThenIsNotAnAct:
      "La excelencia entonces, no es un acto, sino un hábito",
    focusOnBeing: "Concéntrate en ser",
    productiveInsteadOfBusy: "productivo en lugar de ocupado.",
    keyToAchievingSuccess: "Una clave para lograr el éxito",
    assembleStrongStableManagementTeam:
      "es formar un equipo de gestión fuerte y estable.",
    top5: "Top 5",
    ofTheDay: "del día",
    productive: "Productivo",
    unproductive: "Improductivo",
    uncategorized: "Sin categorizar",
    myPowersAreOrdinary: "Mis poderes son ordinarios",
    onlyMyApplicationBringsMeSuccess: "Solo mi aplicación me trae éxito.",
    disconnectingFromOurTechnology: "Desconectarnos de nuestra tecnología",
    toReconnectWithOurselvesIsAbsolutelyEssential:
      "para reconectarnos con nosotros mismos es absolutamente esencial.",
    total: "Total",
    hrs: "hrs",
    appTitle: "Título de la aplicación",
    urls: "URLs",
    noActivity: "Sin actividad",
    pageTitle: "Título de la página",
    timeSpentOnAppTitle: "Tiempo empleado en el título de la aplicación",
    timeSpentOnURLs: "Tiempo empleado en URLs",
    keyStrokes: "Pulsaciones de teclas",
    copy: "Copiar",
    dailyInsights: "Información diaria",
    keyLogger: "Registrador de teclas",
    clear: "Limpiar",
    // Export headers
    teamMembers: "Miembros del Equipo",
    managerEmailAddress: "Dirección de Correo Electrónico del Gerente",
    applicationName: "Nombre de la Aplicación",
    applicationTitle: "Título de la Aplicación",
    keyLogs: "Registros de Teclas",
    activityStartTime: "Hora de Inicio de Actividad",
    activityEndTime: "Hora de Fin de Actividad",
    appTimeSpent: "Tiempo Empleado en la Aplicación",
    timeSlot: "Franja Horaria",
    category: "Categoría",
    url: "URL",
    domain: "Dominio",
    browser: "Navegador",
    urlTimeSpent: "Tiempo Empleado en URL",
    // Export file names
    dailyActivity: "Actividad Diaria",
    categorizeApps: "Categorizar aplicaciones",
    categorizeURLs: "Categorizar URLs",
    noActivitiesTrackedYetForThisDay:
      "No hay actividades registradas para este día.",
    youCanConfigureToCapture: "Puede configurar para capturar los",
    detailsBy: "detalles",
    clickingHere: "haciendo clic aquí.",
    noMatchingSearchResultsFound:
      "No se encontraron resultados de búsqueda coincidentes.",
    applicationNameTitle: "Nombre/Título de la aplicación",
    processName: "Nombre del proceso",
    percentageOfTimeSpent: "Porcentaje de tiempo empleado",
    domainURLs: "Dominio/URLs",
    recentSnap: "captura reciente",
    somethingWentWrongWhileRetrievingSelectedEmployeeWorkScheduleDetails:
      "Algo salió mal al recuperar los detalles del horario de trabajo del empleado seleccionado. Inténtelo de nuevo después de un tiempo.",
    checkInCheckOut: "Entrada - Salida",
    userActiveTime: "Tiempo activo del usuario",
    computerActivities: "Actividades del ordenador",
    idleAndNotActiveTime: "Tiempo ocioso y no activo",
    neutral: "Neutral",
    systemProductivity: "Productividad del sistema",

    // Hourly Activities
    activities: "Actividades",
    from: "desde",
    screenshots: "Capturas de pantalla",
    apps: "Aplicaciones",
    timeSpent: "Tiempo empleado",
    percentage: "Porcentaje",
    desktopClientStatusLog: "Registro de estado del cliente de escritorio",
    internetStatus: "Estado de Internet",
    noBrowsingActivities: "No hay actividades de navegación",
    errorFetchingActivities:
      "Algo salió mal al obtener las actividades. Por favor, inténtelo de nuevo más tarde.",
    technicalDifficultiesWhileFetchingActivities:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener las actividades. Por favor, inténtelo de nuevo más tarde.",
    noAccessToViewHourlyActivities:
      "Lo sentimos, no tienes acceso para ver tus actividades por hora. Ponte en contacto con el administrador de la plataforma.",
    errorFetchingEmployeeAppsURLsInsights:
      "Algo salió mal al obtener la información de aplicaciones/URLs del empleado. Si continúas viendo este problema, ponte en contacto con el administrador de la plataforma.",
    errorFetchingActivitiesContactAdmin:
      "Algo salió mal al obtener las actividades. Si continúas viendo este problema, ponte en contacto con el administrador de la plataforma.",
    noActivitiesToExport: "No hay actividades para exportar los datos diarios",
    activityStatus: "Estado de actividad",
    activityDurationInMinutes: "Duración de actividad (En minutos)",
    appsTimeSpentPercentage:
      "Aplicaciones - Tiempo empleado (HH:MM:SS) - Porcentaje (%)",
    domainTimeSpentPercentage:
      "Dominio - Tiempo empleado (HH:MM:SS) - Porcentaje (%)",
    workLocation: "Ubicación de trabajo",
    ipInfo: "Información IP",

    // Employee Onboard List Popup
    online: "En línea",
    offline: "Desconectado",
    connected: "Conectado",
    disconnected: "Desconectado",
    away: "Ausente",
    notify: "Notificar",
    changeEmployee: "Cambiar Empleado",
    search: "Buscar",
    avatar: "Avatar",

    // ListBusinessAndCollaborativeAppsCard translations
    businessAndCollaborative: "Negocios y Colaborativo",
    applicationType: "Tipo de Aplicación",
    noAppsMatchYourSearch: "No hay aplicaciones que coincidan con tu búsqueda",
    noAppsToList: "No hay aplicaciones para listar.",
    noAppData: "Sin Datos de Aplicación",

    // ActivityReportsChart translations
    activity: "Actividad",
    myTeamWorkedHours: "Horas Trabajadas de Mi Equipo",
    noActivityForSelectedDay: "No hay actividad para el día seleccionado",
    somethingWentWrongFetchingActivityReports:
      "Algo salió mal al obtener los informes de actividad. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongFetchingActivityReportsContactAdmin:
      "Algo salió mal al obtener los informes de actividad. Si continúa viendo este problema, póngase en contacto con el administrador del sistema.",
    computerActivityTime: "Tiempo de Actividad del Ordenador",
    hours24HoursFormat: "Horas (formato de 24 horas)",
    timeInMinutes: "Tiempo (En Minutos)",
    atTime: "A las ",
    hoursTime: ":00 horas",
    workedHoursLabel: "Horas Trabajadas ",
    productiveHours: "Horas Productivas ",

    // ActivityReportsDataTable translations
    myTeamMembers: "Miembros de Mi Equipo",
    searchEmployee: "Buscar Empleado",
    myTeam: "Mi Equipo",
    inviteTeamMembersToTrackActivities:
      "Por favor, invita a los miembros de tu equipo para rastrear sus actividades.",
    technicalDifficultiesActivityReports:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    noAccessRightsToUpdateSettings:
      "No tienes permiso para actualizar esta configuración.",
    somethingWentWrongFetchingActivityReportsTime:
      "Algo salió mal al obtener los informes de actividad. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongFetchingActivityReportsAdmin:
      "Algo salió mal al obtener los informes de actividad. Si continúa viendo este problema, póngase en contacto con el administrador del sistema.",
    somethingWentWrongFetchingActivityReportsComma:
      "Algo salió mal al obtener los informes de actividad. Por favor, inténtelo después de un tiempo,",
    employeeNameHeader: "Miembros",

    // ActivityTrackerReports.vue translations
    allReports: "Todos los Informes",
    insights: "Información",
    dailyReport: "InformeDiario",
    somethingWentWrongDownloadingReports:
      "Algo salió mal al descargar los informes. Por favor, inténtelo después de un tiempo.",

    // EmpListCalendarView.vue translations
    totalEmployeesPresent: "Total de empleados presentes",
    loading: "Cargando...",
    workInProgress: "Trabajo en Progreso",
    present: "Presente",
    absent: "Ausente",
    tracking: "Rastreando",
    tracked: "Rastreado",
    notTracking: "No Rastreando",
    notTracked: "No Rastreado",
    weekOff: "Día Libre",
    overworked: "Sobrecargado",
    normal: "Normal",
    underutilized: "Subutilizado",

    // Days of the week
    sun: "DOM",
    mon: "LUN",
    tue: "MAR",
    wed: "MIÉ",
    thu: "JUE",
    fri: "VIE",
    sat: "SÁB",

    // EmployeeAnalyticalMoreDetailsCard.vue translations
    systemUpTimeDetail: "Tiempo de actividad del sistema",
    totalTimeSpentOnComputerDetail: "Tiempo total empleado en el ordenador.",
    idleTimeDetail: "Tiempo Ocioso",
    idleTimeOnComputer: "Tiempo ocioso en el ordenador.",
    userActiveTimeDetail: "Tiempo activo del usuario",
    userActiveTimeExcludingIdleTimeDetail:
      "Tiempo activo del usuario en el ordenador excluyendo el tiempo 'No activo' y 'Ocioso'.",
    computerActivityTimeDetail: "Tiempo de Actividad de la Computadora",
    computerActivitiesMeasured:
      "El tiempo de actividad de la computadora se mide en función de la participación del usuario en el teclado y el mouse.",
    computerActivitiesMeasuredDetail:
      "El tiempo de actividad del ordenador se mide en base a la interacción del usuario con el teclado y el ratón.",
    systemProductivityDetail: "Productividad del Sistema",
    checkInCheckOutDetail: "Entrada - Salida",
    checkInOutDescription:
      "La entrada representa la primera actividad del usuario en el sistema y la salida representa la última actividad del usuario en el sistema según la configuración del horario de trabajo",
    userProductivityDetail: "Productividad del Usuario",
    userProductivityDescription:
      "El porcentaje de productividad del usuario se mide en base a aplicaciones y sitios web productivos y neutrales contra el tiempo total en la aplicación.",
    productiveLabel: "Productivo",
    timeSpentOnProductiveApps:
      "Tiempo empleado en aplicaciones y sitios web clasificados como productivos.",
    unproductiveLabel: "Improductivo",
    timeSpentOnUnproductiveApps:
      "Tiempo empleado en aplicaciones y sitios web clasificados como improductivos.",
    neutralLabel: "Neutral",
    timeSpentOnUncategorizedApps:
      "Tiempo empleado en aplicaciones y sitios web que no están clasificados (Sin categorizar).",
    hoursText: "horas",
    minutesText: "minutos",

    // Team Activity Error Messages
    errorFetchingTeamActivityDetails:
      "Algo salió mal al obtener los detalles de actividad del equipo. Por favor, inténtelo después de un tiempo.",
    technicalDifficultiesTeamActivity:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    noAccessToViewTeamActivityDetails:
      "Lo sentimos, no tiene acceso para ver los detalles de actividad del equipo.",
    errorFetchingTeamProductivityDetails:
      "Algo salió mal al obtener los detalles de productividad del equipo. Por favor, inténtelo después de un tiempo.",
    technicalDifficultiesTeamProductivity:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    noAccessToViewTeamProductivityDetails:
      "Lo sentimos, no tiene acceso para ver los detalles de productividad del equipo.",

    // Team Summary
    basedOnFixedDailyWorkHoursOf:
      "Basado en horas de trabajo diarias fijas de ",
    basedOnEachEmployeeFixedDailyWorkHours:
      "Basado en las horas de trabajo diarias fijas de cada empleado. Predeterminado: ",
    includesIdleAndNotActiveTime: "Incluye tiempo ocioso y no activo",
    excludesIdleAndNotActiveTime: "Excluye tiempo ocioso y no activo",
    totalTimeSpentOnComputer: "Tiempo total empleado en la computadora.",
    userActiveTimeExcludingIdleTime:
      "Tiempo activo del usuario en la computadora excluyendo el tiempo 'No activo' y 'Ocioso'.",
    noUserActivities: "Sin actividades de usuario",
    averagePerShift: "Promedio por turno",
    noSystemActivities: "Sin actividades del sistema",
    productiveTime: "Tiempo productivo",
    productiveTimeOnApps:
      "Tiempo productivo en aplicaciones y sitios web clasificados como productivos y neutrales.",
    noProductiveActivities: "Sin actividades productivas",
    productiveAndNeutralApps:
      "(Aplicaciones y sitios web productivos y neutrales)",
    userProductivity: "Productividad del usuario",
    userProductivityPercentage:
      "Porcentaje de productividad del usuario en aplicaciones y sitios web productivos y neutrales.",

    // Tooltip descriptions for table headers
    systemUpTimeHoverMessage:
      "El tiempo de actividad del sistema se mide en base al tiempo total empleado en el ordenador.",
    computerActivitiesDescription:
      "Las actividades del ordenador se miden en función de la interacción del usuario con el teclado y el ratón.",
    idleAndNotActiveTimeDescription:
      "Tiempo ocioso y no activo en el ordenador.",
    productiveTimeDescription:
      "Tiempo dedicado a aplicaciones y sitios web clasificados como productivos.",
    unproductiveTimeDescription:
      "Tiempo dedicado a aplicaciones y sitios web clasificados como improductivos.",
    neutralTimeDescription:
      "Tiempo dedicado a aplicaciones y sitios web que no están clasificados (Sin categorizar).",
    userProductivityTooltipDescription:
      "Porcentaje de productividad del usuario en aplicaciones y sitios web productivos y neutrales.",
    privacyOn: "Privacidad Activada",
    privacyModeAlertMessage:
      "Los datos de actividad como productividad, capturas de pantalla y URLs no pueden ser revisados en detalle en modo privado. Para un informe resumido de productividad, por favor navegue a",
    reportsLink: "informes",
    reminderEmailSubject:
      "Recordatorio para comenzar a rastrear tu actividad de hoy",
    reminderEmailContent:
      "Por favor, comienza a rastrear para registrar tu actividad para que tu esfuerzo no sea en vano.",
    inHours: "(En Horas)",
    notifyOfflineEmployeesTooltip:
      'Notifica a los empleados desconectados para que comiencen a rastrear sus actividades usando la aplicación de escritorio. Por favor, selecciona empleados que no estén rastreando y haz clic en "Notificar."',

    // System productivity help text translations
    againstFixedDailyWorkHoursConfiguredByAdmin:
      "contra las horas de trabajo diarias fijas configuradas por el administrador.",
    againstTotalSystemTime: "contra el tiempo total del sistema.",
    againstTotalUserActiveTime: "contra el tiempo total activo del usuario.",
    systemProductivityPercentageDescription:
      "El porcentaje de productividad del sistema ({idleNotActiveMsg}) se basa en la interacción del usuario con el teclado y el ratón {lastMsg}",

    // Activity Tracker Summary
    activitySummary: "Resumen de Actividad",
    appUsageSummary: "Resumen de Uso de Aplicaciones",
    individualOption: "Individual",
    teamOption: "Equipo",
    noOption: "No",
    yesOption: "Sí",
    internetUsageSummary: "Resumen de Uso de Internet",
    totalTimeSpent: "Tiempo Total Empleado",
    activitiesAreNotYetBeingMonitoredForThisDate:
      "Las actividades aún no están siendo monitoreadas para esta fecha.",
    applicationUsageForThisDateHasNotYetBeenTracked:
      "El uso de aplicaciones para esta fecha aún no ha sido rastreado.",
    internetUsageForThisDateHasNotYetBeenTracked:
      "El uso de Internet para esta fecha aún no ha sido rastreado.",
    activeTime: "Tiempo Activo",
    idleTime: "Tiempo Ocioso",
    notActiveTime: "Tiempo No Activo",

    // AdditionalInsights.vue
    unknown: "Desconocido",
    noInternetActivitiesTrackedYetForThisDay:
      "No hay actividades de internet registradas para este día.",
    technicalDifficultiesWhileFetchingInternetStatus:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener el estado de internet. Por favor, inténtelo después de un tiempo.",
    noAccessToViewDailyInsights:
      "Lo sentimos, no tiene acceso para ver sus informes diarios. Póngase en contacto con el administrador de la plataforma.",
    errorFetchingInternetStatus:
      "Algo salió mal al obtener el estado de internet. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",

    // KeyStrokes.vue
    appsUsageDetails: "detalles de uso de aplicaciones",
    by: "mediante",
    technicalDifficultiesWhileFetchingApps:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los detalles de uso de aplicaciones. Por favor, inténtelo después de un tiempo.",
    noAccessRightsToViewApps:
      "Lo sentimos, no tiene derechos de acceso para ver los detalles de sus aplicaciones. Póngase en contacto con el administrador de RRHH.",
    errorFetchingApps:
      "Algo salió mal al obtener los detalles de uso de aplicaciones. Si continúa viendo este problema, comuníquese con el equipo de soporte de la plataforma.",

    // Error messages
    chooseAtLeastOneRecordForResend:
      "Para reenviar, debe elegir al menos un registro.",

    // AssetListCard
    macAddressLabel: "Dirección MAC",
    systemUserNameLabel: "Nombre de Usuario del Sistema",
    noAssetsToAssignForTeamMembers:
      "No hay activos para asignar a los miembros del equipo",
    technicalDifficultiesWhileFetchingAssets:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los activos. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingAssets:
      "Algo salió mal al obtener los activos. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",

    // EditAdminMembers
    cannotDeactivateEmployeeWithReportees:
      "No se puede desactivar al empleado con subordinados: ",
    assignNewManagerBeforeDeactivation:
      "Por favor, asigne un nuevo gerente antes de la desactivación.",
    adminsManagersDetailsUpdatedSuccessfully:
      "Detalles de Administradores/Gerentes actualizados con éxito.",
    technicalDifficultiesWhileAssociatingNewManager:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al asociar el nuevo gerente. Por favor, inténtelo después de un tiempo.",
    unableToAssociateNewManagerRecordDeleted:
      "No se puede asociar un nuevo gerente ya que el registro del gerente se eliminó en la misma u otra sesión de usuario.",
    unableToAssociateNewManagerOtherUserEditing:
      "No se puede asociar un nuevo gerente ya que otro usuario está editando este registro.",
    somethingWentWrongWhileAssociatingNewManager:
      "Algo salió mal al asociar el nuevo gerente. Si continúa viendo este problema, comuníquese con el equipo de soporte de la plataforma.",
    technicalDifficultiesWhileUpdatingAdminMember:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al actualizar el miembro administrador. Por favor, inténtelo después de un tiempo.",
    unableUpdateAdminDetailsEmailExists:
      "No se pueden actualizar los detalles del administrador ya que la dirección de correo electrónico ya existe.",
    unableToUpdateAdminDetailsRecordDeleted:
      "No se pueden actualizar los detalles del administrador ya que el registro del administrador se eliminó en la misma u otra sesión de usuario.",
    employeeIdAlreadyExist: "El ID de empleado ya existe",
    somethingWentWrongWhileUpdatingAdminMember:
      "Algo salió mal al actualizar el miembro administrador. Si continúa viendo este problema, comuníquese con el equipo de soporte de la plataforma.",
    somethingWentWrongWhileUpdatingAdminMemberAdmin:
      "Algo salió mal al actualizar el miembro administrador. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    somethingWentWrongWhileCheckingEmployeeIdAdmin:
      "Algo salió mal al verificar si el ID de empleado ya existe o no. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    screenshotsDownloadedSuccessfully:
      "Capturas de pantalla descargadas con éxito.",
    errorDownloadingScreenshots:
      "Algo salió mal al descargar las capturas de pantalla. Por favor, inténtelo de nuevo más tarde.",
    screenshotZipRequested:
      "Preparando capturas de pantalla. El enlace de descarga se le enviará por correo electrónico.",
    selectScreenshotsToDownload: "Selecciona capturas para descargar",
    screenshotsSkipped:
      "{count} captura(s) de pantalla no se pudieron descargar y se omitieron.",
    technicalDifficultiesWhileFetchingActivitySummaries:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los resúmenes de actividad {activityCategory}. Por favor, inténtelo después de un tiempo.",
    technicalDifficultiesWhileFetchingAppSummaryDetails:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los detalles del resumen de la aplicación {activityCategory}. Por favor, inténtelo después de un tiempo.",
    technicalDifficultiesWhileFetchingInternetSummaryDetails:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los detalles del resumen de Internet {activityCategory}. Por favor, inténtelo después de un tiempo.",
    noAccessRightsToViewAppSummaryDetails:
      "Lo sentimos, no tiene derechos de acceso para ver los detalles del resumen de la aplicación {activityCategory}.",
    noAccessRightsToViewInternetSummaryDetails:
      "Lo sentimos, no tiene derechos de acceso para ver los detalles del resumen de Internet {activityCategory}.",
    somethingWentWrongWhileFetchingActivitySummary:
      "Algo salió mal al obtener el resumen de actividad {activityCategory}. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingAppSummaryDetails:
      "Algo salió mal al obtener los detalles del resumen de la aplicación {activityCategory}. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingInternetSummaryDetails:
      "Algo salió mal al obtener los detalles del resumen de Internet {activityCategory}. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingActivitySummaryContactAdmin:
      "Algo salió mal al obtener el resumen de actividad {activityCategory}. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    somethingWentWrongWhileFetchingAppSummaryDetailsContactAdmin:
      "Algo salió mal al obtener los detalles del resumen de la aplicación {activityCategory}. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    somethingWentWrongWhileFetchingInternetSummaryDetailsContactAdmin:
      "Algo salió mal al obtener los detalles del resumen de Internet {activityCategory}. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",

    // TeamMembersManualImport.vue
    reachedMaximumUserLimit: "Ha alcanzado el límite máximo de usuarios.",
    purchaseMoreLicenses:
      "Para añadir más miembros, por favor compre más licencias.",
    addLicense: "Añadir Licencia",
    addAtLeastOneMemberToSave: "Añada al menos un miembro para guardar",
    chooseOptionToAddMembers: "Elija una opción para añadir miembros",
    uploadCsvXlsWithDetails: "Cargue CSV/XLS con detalles",
    addUsersManuallyWithDetails: "Añada usuarios manualmente con detalles",

    // HrmsMembersList
    technicalDifficultiesWhileFetchingMembers:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingMembers:
      "Algo salió mal al obtener los miembros. Por favor, inténtelo después de un tiempo.",
    pleaseOnboardTeamMembersToTrackActivities:
      "Por favor, incorpore a los miembros de su equipo para rastrear sus actividades.",
    cannotChangeLastAdminRole:
      "No puede cambiar el rol o el estado del último administrador.",

    // EmpMonitoringMembersList
    forDeleteSelectAtLeastOneRecord:
      "Para eliminar, debe seleccionar al menos un registro.",
    accessDeniedMsgUpdateMemberStatus:
      "Lo sentimos, no tiene derechos para actualizar el estado del miembro. Por favor, contacte al administrador del sistema.",
    noAccessRightsToViewTeamMemberDetails:
      "Lo sentimos, no tiene derechos de acceso para ver los detalles de los miembros del equipo. Por favor, contacte a su administrador.",
    // TeamMembersManualImport.vue error messages
    teamMembersOnboardedSuccessfully:
      "Miembros del equipo incorporados con éxito.",
    membersOnboardedPartially: "Miembro(s) incorporado(s) parcialmente.",
    technicalDifficultiesWhileOnboardingTeamMembers:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al incorporar los miembros del equipo. Por favor, inténtelo más tarde.",
    somethingWentWrongWhileOnboardingTeamMembers:
      "Algo salió mal al incorporar los miembros del equipo. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",

    // MemberInactiveAlert.vue
    memberInactiveAlertMessage:
      '¿Ha exportado los datos del miembro desde el módulo de informes? Hacer que un miembro esté "Inactivo" desencadenará una purga de datos y no podrá recuperar los datos de actividad.',
    memberInactiveAlertConfirmation:
      "¿Está seguro de hacer inactivo a este miembro?",
    continue: "Continuar",

    // MemberExceedWarningModal.vue
    exceedWarning: "advertencia-excedido",
    youHaveReachedMaximumUserLimit:
      "Ha alcanzado el límite máximo de usuarios.",
    purchaseMoreLicensesByClickingButton:
      'Tiene que comprar más licencias haciendo clic en el botón "Añadir Licencia" a continuación.',

    // ChooseExportOptionsModal.vue
    import: "Importar",
    manual: "Manual",
    chooseYourInviteOption: "Elija su opción de invitación",
    bulkImportText:
      "Cargue cualquier archivo CSV, XLS o XLSX con el nombre, apellido, dirección de correo electrónico y rol para la incorporación.",
    manualImportText:
      "Añada uno o más usuarios manualmente con detalles como el nombre, apellido, dirección de correo electrónico y rol para la incorporación.",
    shiftValidationImage: "imagen de validación de turno",

    // ListManagers.vue
    searchManager: "Buscar Gerente",
    clearSearch: "Limpiar Búsqueda",
    noManagersAvailable: "No hay gerentes disponibles",
    somethingWentWrongWhileFetchingManagersList:
      "Algo salió mal al obtener la lista de Gerentes. Por favor, intente de nuevo actualizando la página o contacte al administrador de la plataforma.",
    noManagersFoundMessage:
      "No se encontraron gerentes. Por favor, añada o actualice los miembros con rol de Gerente.",

    // StealthTeamMembersMain.vue
    addTeamMembers: "Añadir Miembros del Equipo",
    bulkAdd: "Añadir en Masa",
    onboardAdminsManagers: "Incorporar Administradores/Gerentes",
    // MembersAdminsList.vue
    adminsManagersHeader: "Administradores/Gerentes",
    employeeNameAdminHeader: "Nombre del Empleado",
    employeesHeader: "Empleados",
    computerNameHeader: "Nombre del Ordenador",
    reportingManagerHeader: "Gerente de Informes",
    roleHeader: "Rol",
    operatingSystemHeader: "Sistema Operativo",
    agentVersionHeader: "Versión del Agente",
    clearAllButton: "Limpiar Todo",
    addTeamMembersButton: "Añadir Miembros del Equipo",
    bulkAddButton: "Añadir en Masa",
    noAdminsManagersMatchSearch:
      "No hay administradores/gerentes que coincidan con su búsqueda",
    noTeamMembersMatchSearch:
      "No hay miembros del equipo que coincidan con su búsqueda",
    tryAgainByChangingFilters:
      "Por favor, inténtelo de nuevo cambiando los filtros o bórrelos para obtener todos los datos.",
    okAdminButton: "Aceptar",
    employeeIdAdminHeader: "ID de Empleado",
    emailAddressHeader: "Dirección de Correo Electrónico",
    managerEmailAddressHeader: "Dirección de Correo Electrónico del Gerente",

    // WorkforceAnalytics.vue translations
    workforceAnalytics: "Análisis de Fuerza Laboral",
    utilizationMarginTitle: "Margen de Utilización",
    workload: "Carga de Trabajo",
    attendance: "Asistencia",
    utilizationMarginTooltip:
      "El margen de utilización se utiliza para evaluar el exceso de trabajo y la subutilización de los miembros del equipo en función del tiempo activo total del usuario y el margen de utilización.",
    workScheduleLabel: "Horario de Trabajo:",
    regularHours: "Horas Regulares:",
    timezoneLabel: "Zona Horaria:",
    days: "Días",
    hoursLabel: "Horas",
    retryButton: "Reintentar",
    noDataAvailableMessage: "No hay datos disponibles",
    noRecordsFound: "No se encontraron registros",
    exportEmployeeBasedAnalyticalReport:
      "Exportar informe analítico basado en empleados",
    exportAttendanceMusterReport: "Exportar informe de asistencia",
    theValueShouldBeGreaterThan0: "El valor debe ser mayor que 0.",
    theValueShouldBeLessThanOrEqualTo: "El valor debe ser menor o igual a",
    filterAppliedToWorkforceAnalyticsForContinuousAbsenceForTheLast:
      "filtro aplicado al análisis de fuerza laboral por ausencia continua durante los últimos",
    workforceAnalyticsAttendanceMusterReport:
      "Informe de Asistencia de Análisis de Fuerza Laboral",
    employeeBasedWorkforceAnalyticalReport:
      "Informe Analítico de la Fuerza Laboral Basado en Empleados",
    somethingWentWrongWhileLoadingWorkforceAnalyticsForm:
      "Algo salió mal al cargar el formulario de análisis de fuerza laboral. Por favor, inténtelo después de un tiempo.",

    // WorkforceAnalytics.vue data translations
    systemUpTimeValue: "Tiempo de actividad del sistema",
    systemUpTimeDescription: "Tiempo total pasado en la computadora.",
    userActiveTimeValue: "Tiempo activo del usuario",
    userActiveTimeDescription:
      "Tiempo activo del usuario en la computadora excluyendo el tiempo 'No activo' y 'Ocioso'.",
    idleTimeValue: "Tiempo Ocioso",
    idleTimeDescription:
      "Tiempo continuo de inactividad del usuario en el sistema basado en el umbral de tiempo ocioso",
    computerActivityTimeValue: "Tiempo de actividad de la computadora",
    computerActivityTimeDescription:
      "El tiempo de actividad de la computadora se mide en función de la interacción del usuario con el teclado y el ratón.",
    userProductiveTimeValue: "Tiempo productivo del usuario",
    userProductiveTimeDescription:
      "Tiempo dedicado a aplicaciones y sitios web clasificados como productivos.",
    continuousAbsenceValue: "Ausencia continua durante los últimos",
    continuousAbsenceDescription:
      "Dentro del mes actual, ausencia continua de un empleado desde hoy.",

    // Report headers
    employeeIdHeader: "ID de Empleado",
    employeeLastNameHeader: "Apellido del Empleado",
    employeeFirstNameHeader: "Nombre del Empleado",
    employeeEmailHeader: "Dirección de Correo Electrónico del Empleado",
    managerHeader: "Gerente",
    applicationHeader: "Aplicación",
    urlHeader: "URL",
    domainHeader: "Dominio",
    browserHeader: "Navegador",
    timeSpentHeader: "Tiempo Empleado",
    pageTitleHeader: "Título de la Página",
    processNameHeader: "Nombre del Proceso",
    categoryHeader: "Categoría",
    percentageHeader: "Porcentaje",
    workLocationHeader: "Ubicación de Trabajo",
    ipInfoHeader: "Información IP",
    timeSlotHeader: "Franja Horaria",
    activityStatusHeader: "Estado de Actividad",
    activityDurationInMinutesHeader: "Duración de Actividad (En Minutos)",
    fileNameHeader: "Nombre del Archivo",
    filePathHeader: "Ruta del Archivo",
    fileSizeHeader: "Tamaño del Archivo",
    fileExtensionHeader: "Extensión del Archivo",
    eventTypeHeader: "Tipo de Evento",
    windowTitleHeader: "Título de la Ventana",
    keyStrokesHeader: "Pulsaciones de Teclas",
    mouseClicksHeader: "Clics del Ratón",
    screenshotsCountHeader: "Cantidad de Capturas de Pantalla",
    totalTimeWorkedHeader: "Tiempo Total Trabajado",
    totalTimeWorkedInMinutesHeader: "Tiempo Total Trabajado (En Minutos)",
    activityDateHeader: "Fecha de Actividad",
    checkInTimeHeader: "Hora de Entrada",
    checkOutTimeHeader: "Hora de Salida",
    systemUpTimeHeader: "Tiempo de Actividad del Sistema",
    systemUpTimeInHoursHeader: "Tiempo de Actividad del Sistema (En Horas)",
    userActiveTimeHeader: "Tiempo Activo del Usuario",
    userActiveTimeInHoursHeader: "Tiempo Activo del Usuario (En Horas)",
    computerActivityTimeHeader: "Tiempo de Actividad de la Computadora",
    computerActivityTimeInHoursHeader:
      "Tiempo de Actividad de la Computadora (En Horas)",
    idleTimeHeader: "Tiempo Ocioso",
    idleTimeInHoursHeader: "Tiempo Ocioso (En Horas)",
    systemProductivityPercentageHeader: "Productividad del Sistema %",
    productiveTimeHeader: "Tiempo Productivo",
    productiveTimeInHoursHeader: "Tiempo Productivo (En Horas)",
    unproductiveTimeHeader: "Tiempo Improductivo",
    neutralTimeHeader: "Tiempo Neutral",
    userProductivityPercentageHeader: "Productividad del Usuario %",
    weekOffHeader: "Fin de Semana",
    selectToDownload: "Seleccionar para descargar las capturas de pantalla",
    previewInScreenshots:
      "La imagen se puede previsualizar en la pestaña de capturas de pantalla",
    technicalDifficultiesWhileFetchingEmployeeRoles:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los roles del empleado. Por favor, inténtelo después de un tiempo.",
    technicalDifficultiesWhileFetchingEmployeeRolesContactAdmin:
      "Se produjo un error al obtener los roles de los empleados. Si el problema persiste, comuníquese con el administrador de la plataforma.",
    minutes: "minutos",
    of: "de",

    // Additional report headers for AllReportsExportModal
    checkinDateTimeHeader: "Fecha y Hora de Entrada",
    checkoutDateTimeHeader: "Fecha y Hora de Salida",
    trackingStatusHeader: "Estado de Seguimiento",
    totalSystemUpTimeHeader: "Tiempo Total del Sistema Activo",
    totalUserActiveTimeHeader: "Tiempo Total Activo del Usuario",
    userActiveTimeKeyboardMouseHeader:
      "Tiempo Activo del Usuario en Teclado y Ratón",
    timeSpentIdleNotActiveHeader: "Tiempo en Ocioso y No Activo",
    systemProductivityIncludesIdleHeader:
      "Productividad del Sistema % (Incluye Tiempo Ocioso y No Activo)",
    systemProductivityExcludesIdleHeader:
      "Productividad del Sistema % (Excluye Tiempo Ocioso y No Activo)",
    timeZoneHeader: "Zona Horaria",
    attendanceSessionTimeHeader: "Tiempo de Sesión de Asistencia",
    attendanceSessionTimeMinutesHeader:
      "Tiempo de Sesión de Asistencia (En Minutos)",
    systemProductivityFixedHoursHeader:
      "Productividad del Sistema % (Basado en Horas de Trabajo Fijas Diarias)",
    totalIdleTimeHeader: "Tiempo Total Ocioso",
    totalIdleTimeMinutesHeader: "Tiempo Total Ocioso (En Minutos)",
    totalNotActiveTimeHeader: "Tiempo Total No Activo",
    totalNotActiveTimeMinutesHeader: "Tiempo Total No Activo (En Minutos)",
    timeSpentIdleNotActiveMinutesHeader:
      "Tiempo en Ocioso y No Activo (En Minutos)",
    totalSystemUpTimeMinutesHeader:
      "Tiempo Total del Sistema Activo (En Minutos)",
    totalUserActiveTimeMinutesHeader:
      "Tiempo Total Activo del Usuario (En Minutos)",
    userActiveTimeKeyboardMouseMinutesHeader:
      "Tiempo Activo del Usuario en Teclado y Ratón (En Minutos)",
    totalSystemActiveTimeWithoutLockAppHeader:
      "Tiempo Total del Sistema Activo Sin Aplicación de Bloqueo",
    totalSystemActiveTimeWithoutLockAppMinutesHeader:
      "Tiempo Total del Sistema Activo Sin Aplicación de Bloqueo (En Minutos)",
    totalLockAppTimeHeader: "Tiempo Total de Aplicación de Bloqueo",
    totalLockAppTimeMinutesHeader:
      "Tiempo Total de Aplicación de Bloqueo (En Minutos)",
  },
};
